export var highLightedMarketCategories = {
    futbol: [
        {
            name: 'Maç Sonucu',
            pre: '5498',
            live: '5498',
            outcomeCount: 3,
            priority: 0,
            labels: ['1', '0', '2'],
        },
        {
            name: 'Alt/Üst 2,5',
            pre: '5500-2.5',
            live: '5500-2.5',
            outcomeCount: 2,
            priority: 1,
            labels: ['Üst', 'Alt'],
        },
        {
            name: 'Çifte Şans',
            pre: '92',
            live: '129',
            outcomeCount: 3,
            priority: 4,
            labels: ['1 ve 0', '1 ve 2', '0 ve 2'],
        },
        {
            name: 'Karşılıklı Gol',
            pre: '5508',
            live: '5508',
            outcomeCount: 2,
            priority: 2,
            labels: ['Var', 'Yok'],
        },
        {
            name: 'Alt/Üst 2,5',
            pre: '5500-2.5',
            live: '5500-2.5',
            outcomeCount: 2,
            priority: 1,
            labels: ['Üst', 'Alt'],
        },
        {
            name: 'Alt/Üst 1,5',
            pre: '5500-2.5',
            live: '5500-2.5',
            outcomeCount: 2,
            priority: 5,
            labels: ['Üst', 'Alt'],
        },
        {
            name: 'Alt/Üst 3,5',
            pre: '5500-2.5',
            live: '5500-2.5',
            outcomeCount: 2,
            priority: 6,
            labels: ['Üst', 'Alt'],
        },
        {
            name: 'İlk Yarı Alt/Üst 0.5',
            pre: '5500-2.5',
            live: '5500-2.5',
            outcomeCount: 2,
            priority: 7,
            labels: ['Üst', 'Alt'],
        },
        {
            name: 'İlk Yarı Alt/Üst 1.5',
            pre: '5500-2.5',
            live: '5500-2.5',
            outcomeCount: 2,
            priority: 8,
            labels: ['Üst', 'Alt'],
        },
        {
            name: 'İlk Yarı Sonucu',
            pre: '88',
            live: '47',
            outcomeCount: 3,
            priority: 9,
            labels: ['1', '0', '2'],
        },
        // {
        //   name: 'Toplam Gol',
        //   pre: '4',
        //   live: '4',
        //   outcomeCount: 4,
        //   priority: 10
        // }
    ],
    "football-canli": [
        {
            name: 'Maç Sonucu',
            pre: '5498',
            live: '5498',
            outcomeCount: 3,
            priority: 0,
            labels: ['1', '0', '2'],
        },
        {
            name: 'Toplam Alt/Üst',
            pre: '5500',
            live: '5500',
            outcomeCount: 2,
            priority: 1,
            labels: ['Üst', 'Alt'],
        },
        {
            name: 'Next Goal',
            pre: '5506',
            live: '5506',
            outcomeCount: 3,
            priority: 9,
            labels: ['T1', 'X', 'T2'],
        },
        {
            name: 'Çifte Şans',
            pre: '5499',
            live: '5499',
            outcomeCount: 3,
            priority: 4,
            labels: ['1X', '12', 'X2'],
        },
        {
            name: 'Karşılıklı Gol',
            pre: '5508',
            live: '5508',
            outcomeCount: 2,
            priority: 2,
            labels: ['Var', 'Yok'],
        },
        {
            name: 'İlk Yarı Toplam Alt/Üst',
            pre: '5520',
            live: '5520',
            outcomeCount: 2,
            priority: 8,
            labels: ['Üst', 'Alt'],
            // row: 2,
            // halfTimeOf: 5500,
        },
        {
            name: 'İlk Yarı Sonucu',
            pre: '5518',
            live: '5518',
            outcomeCount: 3,
            priority: 9,
            labels: ['1', '0', '2'],
            // row: 2,
            // halfTimeOf: 5498,
        },
        {
            name: 'Rest Of The Match',
            pre: '12553',
            live: '12553',
            outcomeCount: 3,
            priority: 9,
            labels: ['W1', 'X', 'W2'],
        },
        {
            name: 'İlk Golü Hangi Takım Atar',
            pre: '87',
            live: '87',
            outcomeCount: 3,
            priority: 9,
            labels: ['1', '0', '2'],
        },
    ],
    "e-football-canli": [
        {
            name: 'Maç Sonucu',
            pre: '5498',
            live: '5498',
            outcomeCount: 3,
            priority: 0,
            labels: ['1', '0', '2'],
        },
        {
            name: 'Alt/Üst 2,5',
            pre: '386-2.5',
            live: '386-2.5',
            outcomeCount: 2,
            priority: 1,
            labels: ['Üst', 'Alt'],
        },
        {
            name: 'Çifte Şans',
            pre: '5499',
            live: '5499',
            outcomeCount: 3,
            priority: 4,
            labels: ['1 ve 0', '1 ve 2', '0 ve 2'],
        },
        {
            name: 'Karşılıklı Gol',
            pre: '5508',
            live: '5508',
            outcomeCount: 2,
            priority: 2,
            labels: ['Var', 'Yok'],
        },
        {
            name: 'Alt/Üst 2,5',
            pre: '101-2.5',
            live: '14-2.5',
            outcomeCount: 2,
            priority: 1,
            labels: ['Üst', 'Alt'],
        },
        {
            name: 'Alt/Üst 1,5',
            pre: '101-1.5',
            live: '14-1.5',
            outcomeCount: 2,
            priority: 5,
            labels: ['Üst', 'Alt'],
        },
        {
            name: 'Alt/Üst 3,5',
            pre: '101-3.5',
            live: '14-3.5',
            outcomeCount: 2,
            priority: 6,
            labels: ['Üst', 'Alt'],
        },
        {
            name: 'İlk Yarı Alt/Üst 0.5',
            pre: '60-0.5',
            live: '63-0.5',
            outcomeCount: 2,
            priority: 7,
            labels: ['Üst', 'Alt'],
        },
        {
            name: 'İlk Yarı Alt/Üst 1.5',
            pre: '60-1.5',
            live: '63-1.5',
            outcomeCount: 2,
            priority: 8,
            labels: ['Üst', 'Alt'],
        },
        {
            name: 'İlk Yarı Sonucu',
            pre: '88',
            live: '47',
            outcomeCount: 3,
            priority: 9,
            labels: ['1', '0', '2'],
        },
        // {
        //   name: 'Toplam Gol',
        //   pre: '4',
        //   live: '4',
        //   outcomeCount: 4,
        //   priority: 10
        // }
    ],
    football: [
        {
            name: 'Maç Sonucu',
            pre: '5498',
            live: '5498',
            outcomeCount: 3,
            priority: 0,
            labels: ['1', '0', '2'],
        },
        {
            name: 'Toplam Alt/Üst',
            pre: '5500',
            live: '5500',
            outcomeCount: 2,
            priority: 1,
            labels: ['Üst', 'Alt'],
        },
        {
            name: 'Çifte Şans',
            pre: '5499',
            live: '5499',
            outcomeCount: 3,
            priority: 4,
            labels: ['1X', '12', 'X2'],
        },
        {
            name: 'Karşılıklı Gol',
            pre: '5508',
            live: '5508',
            outcomeCount: 2,
            priority: 2,
            labels: ['Var', 'Yok'],
        },
        {
            name: 'İlk Yarı Toplam Alt/Üst',
            pre: '5520',
            live: '5520',
            outcomeCount: 2,
            priority: 8,
            labels: ['Üst', 'Alt'],
            row: 2,
            halfTimeOf: 5500,
        },
        // {
        //     name: 'İlk Yarı Alt/Üst 0.5',
        //     pre: '5520-0.5',
        //     live: '5520-0.5',
        //     outcomeCount: 2,
        //     priority: 7,
        //     labels: ['Üst', 'Alt'],
        // },
        // {
        //     name: 'İlk Yarı Alt/Üst 1.5',
        //     pre: '5520-1.5',
        //     live: '5520-1.5',
        //     outcomeCount: 2,
        //     priority: 8,
        //     labels: ['Üst', 'Alt'],
        // },
        {
            name: 'İlk Yarı Sonucu',
            pre: '5518',
            live: '5518',
            outcomeCount: 3,
            priority: 9,
            labels: ['1', '0', '2'],
            row: 2,
            halfTimeOf: 5498,
        },
        {
            name: 'Rest Of The Match',
            pre: '12553',
            live: '12553',
            outcomeCount: 3,
            priority: 9,
            labels: ['W1', 'X', 'W2'],
        },
        {
            name: 'Next Goal',
            pre: '5506',
            live: '5506',
            outcomeCount: 3,
            priority: 9,
            labels: ['T1', 'X', 'T2'],
        },
        {
            name: 'İlk Golü Hangi Takım Atar',
            pre: '87',
            live: '87',
            outcomeCount: 3,
            priority: 9,
            labels: ['1', '0', '2'],
        },
    ],
    "e-football": [
        {
            name: 'Maç Sonucu',
            pre: '5498',
            live: '5498',
            outcomeCount: 3,
            priority: 0,
            labels: ['1', '0', '2'],
        },
        {
            name: 'Alt/Üst 2,5',
            pre: '101-2.5',
            live: '14-2.5',
            outcomeCount: 2,
            priority: 1,
            labels: ['Üst', 'Alt'],
        },
        {
            name: 'Çifte Şans',
            pre: '5499',
            live: '5499',
            outcomeCount: 3,
            priority: 4,
            labels: ['1 0', '1 2', '0 2'],
        },
        {
            name: 'Karşılıklı Gol',
            pre: '5508',
            live: '5508',
            outcomeCount: 2,
            priority: 2,
            labels: ['Var', 'Yok'],
        },
        {
            name: 'Alt/Üst 2,5',
            pre: '101-2.5',
            live: '14-2.5',
            outcomeCount: 2,
            priority: 1,
            labels: ['Üst', 'Alt'],
        },
        {
            name: 'Alt/Üst 1,5',
            pre: '101-1.5',
            live: '14-1.5',
            outcomeCount: 2,
            priority: 5,
            labels: ['Üst', 'Alt'],
        },
        {
            name: 'Alt/Üst 3,5',
            pre: '101-3.5',
            live: '14-3.5',
            outcomeCount: 2,
            priority: 6,
            labels: ['Üst', 'Alt'],
        },
        {
            name: 'İlk Yarı Alt/Üst 0.5',
            pre: '60-0.5',
            live: '63-0.5',
            outcomeCount: 2,
            priority: 7,
            labels: ['Üst', 'Alt'],
        },
        {
            name: 'İlk Yarı Alt/Üst 1.5',
            pre: '60-1.5',
            live: '63-1.5',
            outcomeCount: 2,
            priority: 8,
            labels: ['Üst', 'Alt'],
        },
        {
            name: 'İlk Yarı Sonucu',
            pre: '88',
            live: '47',
            outcomeCount: 3,
            priority: 9,
            labels: ['1', '0', '2'],
        },
        // {
        //   name: 'Toplam Gol',
        //   pre: '4',
        //   live: '4',
        //   outcomeCount: 4,
        //   priority: 10
        // }
    ],
    duello: [
        {
            name: 'Maç Sonucu',
            pre: '770',
            live: '770',
            outcomeCount: 3,
            priority: 0,
            labels: ['1', '0', '2'],
        },
        {
            name: 'Toplam Alt/Üst',
            pre: '772',
            live: '772',
            outcomeCount: 2,
            priority: 1,
            labels: ['Üst', 'Alt'],
        },
    ],
    basketbol: [
        {
            name: 'Maç Sonucu',
            pre: '4476',
            live: '4476',
            priority: 0,
            outcomeCount: 2,
            labels: ['1', '2'],
        },
        {
            name: 'Toplam Alt/Üst',
            pre: '114',
            live: '140',
            priority: 0,
            outcomeCount: 2,
            labels: ['Üst', 'Alt'],
        },
        // {
        //   name: 'H. Maç Sonucu',
        //   pre: '113',
        //   live: '286',
        //   priority: 0,
        //   outcomeCount: 2
        // },
        {
            name: 'İlk Yarı Sonucu',
            pre: '621',
            live: '606',
            priority: 0,
            outcomeCount: 3,
            labels: ['1', '0', '2'],
        },
        {
            name: 'İlk Yarı Toplam Alt/Üst',
            pre: '116',
            live: '64',
            priority: 0,
            outcomeCount: 2,
            labels: ['Alt', 'Üst']
        },
        // {
        //   name: 'İlk Yarı Handikaplı Sonucu',
        //   pre: '115',
        //   live: '115',
        //   priority: 0,
        //   outcomeCount: 2
        // },
        {
            name: 'İlk Çeyrek Sonucu',
            pre: '660',
            live: '673',
            priority: 0,
            outcomeCount: 3,
            labels: ['1', '0', '2'],
        },
        {
            name: 'Ev Sahibi Alt/Üst',
            pre: '619',
            live: '615',
            priority: 0,
            outcomeCount: 2,
            labels: ['Alt', 'Üst']
        },
        {
            name: 'Deplasman Alt/Üst',
            pre: '620',
            live: '616',
            priority: 0,
            outcomeCount: 2,
            labels: ['Alt', 'Üst']
        }
    ],
    basketball: [
        {
            name: 'Maç Sonucu',
            pre: "4476",
            live: "4476",
            priority: 0,
            outcomeCount: 2,
            labels: ['1', '2'],
        },
        {
            name: 'Toplam Alt/Üst',
            pre: '4478',
            live: '4478',
            priority: 0,
            outcomeCount: 2,
            labels: ['Üst', 'Alt'],
        },
        // {
        //   name: 'H. Maç Sonucu',
        //   pre: '113',
        //   live: '286',
        //   priority: 0,
        //   outcomeCount: 2
        // },
        {
            name: 'İlk Yarı Sonucu',
            pre: '621',
            live: '606',
            priority: 0,
            outcomeCount: 3,
            labels: ['1', '0', '2'],
        },
        {
            name: 'İlk Yarı Toplam Alt/Üst',
            pre: '116',
            live: '64',
            priority: 0,
            outcomeCount: 2,
            labels: ['Alt', 'Üst']
        },
        // {
        //   name: 'İlk Yarı Handikaplı Sonucu',
        //   pre: '115',
        //   live: '115',
        //   priority: 0,
        //   outcomeCount: 2
        // },
        {
            name: 'İlk Çeyrek Sonucu',
            pre: '660',
            live: '673',
            priority: 0,
            outcomeCount: 3,
            labels: ['1', '0', '2'],
        },
        {
            name: 'Ev Sahibi Alt/Üst',
            pre: '619',
            live: '615',
            priority: 0,
            outcomeCount: 2,
            labels: ['Alt', 'Üst']
        },
        {
            name: 'Deplasman Alt/Üst',
            pre: '620',
            live: '616',
            priority: 0,
            outcomeCount: 2,
            labels: ['Alt', 'Üst']
        }
    ],
    basket: [
        {
            name: 'Maç Sonucu',
            pre: '2',
            live: '71',
            priority: 0,
            outcomeCount: 2,
            labels: ['1', '2'],
        },
        {
            name: 'Toplam Alt/Üst',
            pre: '4478',
            live: '4478',
            priority: 0,
            outcomeCount: 2,
            labels: ['Üst', 'Alt'],
        },
        // {
        //   name: 'H. Maç Sonucu',
        //   pre: '113',
        //   live: '286',
        //   priority: 0,
        //   outcomeCount: 2
        // },
        {
            name: 'İlk Yarı Sonucu',
            pre: '621',
            live: '606',
            priority: 0,
            outcomeCount: 3,
            labels: ['1', '0', '2'],
        },
        {
            name: 'İlk Yarı Toplam Alt/Üst',
            pre: '116',
            live: '64',
            priority: 0,
            outcomeCount: 2,
            labels: ['Alt', 'Üst']
        },
        // {
        //   name: 'İlk Yarı Handikaplı Sonucu',
        //   pre: '115',
        //   live: '115',
        //   priority: 0,
        //   outcomeCount: 2
        // },
        {
            name: 'İlk Çeyrek Sonucu',
            pre: '660',
            live: '673',
            priority: 0,
            outcomeCount: 3,
            labels: ['1', '0', '2'],
        },
        {
            name: 'Ev Sahibi Alt/Üst',
            pre: '619',
            live: '615',
            priority: 0,
            outcomeCount: 2,
            labels: ['Alt', 'Üst']
        },
        {
            name: 'Deplasman Alt/Üst',
            pre: '620',
            live: '616',
            priority: 0,
            outcomeCount: 2,
            labels: ['Alt', 'Üst']
        }
    ],
    tenis: [
        {
            name: 'Maç Sonucu',
            pre: '9',
            live: '56',
            priority: 0,
            outcomeCount: 2,
            labels: ['1', '2']
        },
        {
            name: 'Toplam Oyun Alt/Üst',
            pre: '168',
            live: '191',
            priority: 0,
            outcomeCount: 2,
            labels: ['Alt', 'Üst']
        },
        // {
        //   name: 'Handikaplı Maç Sonucu',
        //   pre: '649',
        //   live: '613',
        //   priority: 0,
        //   outcomeCount: 2
        // },
        {
            name: '1. Oyuncu Set Kazanır',
            pre: '647',
            live: '607',
            priority: 0,
            outcomeCount: 2,
            labels: ['Evet', 'Hayır'],
        },
        {
            name: '2. Oyuncu Set Kazanır',
            pre: '648',
            live: '608',
            priority: 0,
            outcomeCount: 2,
            labels: ['Evet', 'Hayır'],
        },
        {
            name: '1. Oyuncu Alt/Üst',
            pre: '650',
            live: '622',
            priority: 0,
            outcomeCount: 2,
            labels: ['Üst', 'Alt'],
        },
        {
            name: '2. Oyuncu Alt/Üst',
            pre: '651',
            live: '623',
            priority: 0,
            outcomeCount: 2,
            labels: ['Üst', 'Alt'],
        }
    ],
    tennis: [
        {
            name: 'Maç Sonucu',
            pre: '2434',
            live: '2434',
            priority: 0,
            outcomeCount: 2,
            labels: ['1', '2'],
        },
        {
            name: 'Toplam Oyun Alt/Üst',
            pre: '168',
            live: '191',
            priority: 0,
            outcomeCount: 2,
            labels: ['Üst', 'Alt'],
        },
        // {
        //   name: 'Handikaplı Maç Sonucu',
        //   pre: '649',
        //   live: '613',
        //   priority: 0,
        //   outcomeCount: 2
        // },
        {
            name: '1. Oyuncu Set Kazanır',
            pre: '647',
            live: '607',
            priority: 0,
            outcomeCount: 2,
            labels: ['Evet', 'Hayır'],
        },
        {
            name: '2. Oyuncu Set Kazanır',
            pre: '648',
            live: '608',
            priority: 0,
            outcomeCount: 2,
            labels: ['Evet', 'Hayır'],
        },
        {
            name: '1. Oyuncu Alt/Üst',
            pre: '650',
            live: '622',
            priority: 0,
            outcomeCount: 2,
            labels: ['Üst', 'Alt'],
        },
        {
            name: '2. Oyuncu Alt/Üst',
            pre: '651',
            live: '623',
            priority: 0,
            outcomeCount: 2,
            labels: ['Üst', 'Alt'],
        }
    ],
    'masa-tenisi': [
        {
            name: 'Maç Sonucu',
            pre: '633',
            live: '653',
            priority: 0,
            outcomeCount: 2,
            labels: ['1', '2'],
        }
    ],
    'table-tennis': [
        {
            name: 'Maç Sonucu',
            pre: '633',
            live: '653',
            priority: 0,
            outcomeCount: 2,
            labels: ['1', '2'],
        }
    ],
    'buz-hokeyi': [
        {
            name: 'Maç Sonucu',
            pre: '21',
            live: '653',
            priority: 0,
            outcomeCount: 3,
            labels: ['1', '0', '2'],
        },
        {
            name: 'Toplam Gol Alt/Üst',
            pre: '164',
            live: '21',
            priority: 0,
            outcomeCount: 2,
            labels: ['Üst', 'Alt'],
        },
        // {
        //   name: 'Handikaplı Maç Sonucu',
        //   pre: '163',
        //   live: '9',
        //   priority: 0,
        //   outcomeCount: 3
        // },
        {
            name: 'Çifte Şans',
            pre: '159',
            live: '128',
            priority: 0,
            outcomeCount: 3,
            labels: ['1 ve 0', '1 ve 2', '0 ve 2'],
        }
    ],
    'ice-hockey': [
        {
            name: 'Maç Sonucu',
            pre: '21',
            live: '653',
            priority: 0,
            outcomeCount: 3,
            labels: ['1', '0', '2'],
        },
        {
            name: 'Toplam Gol Alt/Üst',
            pre: '164',
            live: '21',
            priority: 0,
            outcomeCount: 2,
            labels: ['Üst', 'Alt'],
        },
        // {
        //   name: 'Handikaplı Maç Sonucu',
        //   pre: '163',
        //   live: '9',
        //   priority: 0,
        //   outcomeCount: 3
        // },
        {
            name: 'Çifte Şans',
            pre: '159',
            live: '128',
            priority: 0,
            outcomeCount: 3,
            labels: ['1 ve 0', '1 ve 2', '0 ve 2'],
        }
    ],
    voleybol: [
        {
            name: 'Maç Sonucu',
            pre: '399',
            live: '399',
            priority: 0,
            outcomeCount: 2,
            labels: ['1', '2'],
        },
        {
            name: 'Toplam Sayı Alt/Üst',
            pre: '217',
            live: '18',
            priority: 0,
            outcomeCount: 2,
            labels: ['Üst', 'Alt'],
        },
        // {
        //   name: 'Handikaplı Maç Sonucu',
        //   pre: '231',
        //   live: '239',
        //   priority: 0,
        //   outcomeCount: 2
        // }
    ],
    "volleyball": [
        {
            name: 'Maç Sonucu',
            pre: '399',
            live: '399',
            priority: 0,
            outcomeCount: 2,
            labels: ['1', '2'],
        },
        {
            name: 'Toplam Sayı Alt/Üst',
            pre: '217',
            live: '18',
            priority: 0,
            outcomeCount: 2,
            labels: ['Üst', 'Alt'],
        },
        // {
        //   name: 'Handikaplı Maç Sonucu',
        //   pre: '231',
        //   live: '239',
        //   priority: 0,
        //   outcomeCount: 2
        // }
    ],
    hentbol: [
        {
            name: 'Maç Sonucu',
            pre: '16',
            live: '3',
            priority: 0,
            outcomeCount: 3,
            labels: ['1', '0', '2'],
        },
        {
            name: 'Toplam Gol Alt/Üst',
            pre: '191',
            live: '20',
            priority: 0,
            outcomeCount: 2,
            labels: ['Üst', 'Alt'],
        },
        // {
        //   name: 'Handikaplı Maç Sonucu',
        //   pre: '187',
        //   live: '187',
        //   priority: 0,
        //   outcomeCount: 2
        // },
        {
            name: 'Çifte Şans',
            pre: '185',
            live: '633',
            priority: 0,
            outcomeCount: 3,
            labels: ['1 ve 0', '1 ve 2', '0 ve 2'],
        }
    ],
    handball: [
        {
            name: 'Maç Sonucu',
            pre: '16',
            live: '3',
            priority: 0,
            outcomeCount: 3,
            labels: ['1', '0', '2'],
        },
        {
            name: 'Toplam Gol Alt/Üst',
            pre: '191',
            live: '20',
            priority: 0,
            outcomeCount: 2,
            labels: ['Üst', 'Alt'],
        },
        // {
        //   name: 'Handikaplı Maç Sonucu',
        //   pre: '187',
        //   live: '187',
        //   priority: 0,
        //   outcomeCount: 2
        // },
        {
            name: 'Çifte Şans',
            pre: '185',
            live: '633',
            priority: 0,
            outcomeCount: 3,
            labels: ['1 ve 0', '1 ve 2', '0 ve 2'],
        }
    ],
    snooker: [
        {
            name: 'Maç Sonucu',
            pre: '15',
            live: '600',
            priority: 0,
            outcomeCount: 2,
            labels: ['1', '2'],
        },
        {
            name: 'Toplam Frame Alt/Üst',
            pre: '642',
            live: '602',
            priority: 0,
            outcomeCount: 2,
            labels: ['Üst', 'Alt'],
        },
        // {
        //   name: 'Handikaplı Maç Sonucu',
        //   pre: '641',
        //   live: '641',
        //   priority: 0,
        //   outcomeCount: 2
        // }
    ],
    cricket: [
        {
            name: 'Maç Sonucu',
            pre: '15',
            live: '600',
            priority: 0,
            outcomeCount: 2,
            labels: ['1', '2'],
        },
    ],
    politics: [
        {
            name: 'Maç Sonucu',
            pre: '15',
            live: '600',
            priority: 0,
            outcomeCount: 2,
            labels: ['1', '2'],
        },
    ],
    "cricket-canli": [
        {
            name: 'Maç Sonucu',
            pre: '15',
            live: '600',
            priority: 0,
            outcomeCount: 2,
            labels: ['1', '2'],
        },
    ],
    baseball: [
        {
            name: 'Maç Sonucu',
            pre: '15',
            live: '600',
            priority: 0,
            outcomeCount: 2,
            labels: ['1', '2'],
        },
    ],
    darts: [
        {
            name: 'Maç Sonucu',
            pre: '15',
            live: '600',
            priority: 0,
            outcomeCount: 2,
            labels: ['1', '2'],
        },
    ],
    "darts-canli": [
        {
            name: 'Maç Sonucu',
            pre: '15',
            live: '600',
            priority: 0,
            outcomeCount: 2,
            labels: ['1', '2'],
        },
    ],
    badminton: [
        {
            name: 'Maç Sonucu',
            pre: '15',
            live: '600',
            priority: 0,
            outcomeCount: 2,
            labels: ['1', '2'],
        },
    ],
    "greco-roman-wrestling": [
        {
            name: 'Maç Sonucu',
            pre: '15',
            live: '600',
            priority: 0,
            outcomeCount: 2,
            labels: ['1', '2'],
        },
    ],
    "beach-volleyball": [
        {
            name: 'Maç Sonucu',
            pre: '15',
            live: '600',
            priority: 0,
            outcomeCount: 2,
            labels: ['1', '2'],
        },
    ],
    "beach-volleyball-canli": [
        {
            name: 'Maç Sonucu',
            pre: '15',
            live: '600',
            priority: 0,
            outcomeCount: 2,
            labels: ['1', '2'],
        },
    ],
    'motor-sporlar': [
        {
            name: 'Tümü',
            pre: '3-1',
            live: '600',
            priority: 0,
            outcomeCount: 2,
            labels: ['1', '2']
        },
    ],
    mma: [
        {
            name: 'Maç Sonucu',
            pre: '637',
            live: '637',
            priority: 0,
            outcomeCount: 2,
            labels: ['1', '2'],
        }
    ],
    golf: [
        {
            name: 'Maç Sonucu',
            pre: '637',
            live: '637',
            priority: 0,
            outcomeCount: 2,
            labels: ['1', '2'],
        }
    ],
    curling: [
        {
            name: 'Maç Sonucu',
            pre: '637',
            live: '637',
            priority: 0,
            outcomeCount: 2,
            labels: ['1', '2'],
        }
    ],
    "rugby-union": [
        {
            name: 'Maç Sonucu',
            pre: '637',
            live: '637',
            priority: 0,
            outcomeCount: 2,
            labels: ['1', '2'],
        }
    ],
    "floorball": [
        {
            name: 'Maç Sonucu',
            pre: '637',
            live: '637',
            priority: 0,
            outcomeCount: 2,
            labels: ['1', '2'],
        }
    ],
    "futsal": [
        {
            name: 'Maç Sonucu',
            pre: '637',
            live: '637',
            priority: 0,
            outcomeCount: 2,
            labels: ['1', '2'],
        }
    ],
    "dota-2": [
        {
            name: 'Maç Sonucu',
            pre: '637',
            live: '637',
            priority: 0,
            outcomeCount: 2,
            labels: ['1', '2'],
        }
    ],
    "league-of-legends": [
        {
            name: 'Maç Sonucu',
            pre: '637',
            live: '637',
            priority: 0,
            outcomeCount: 2,
            labels: ['1', '2'],
        }
    ],
    'aussie-rules': [{
            name: 'Maç Sonucu',
            pre: '637',
            live: '637',
            priority: 0,
            outcomeCount: 2,
            labels: ['1', '2'],
        }],
    'cycling': [{
            name: 'Maç Sonucu',
            pre: '637',
            live: '637',
            priority: 0,
            outcomeCount: 2,
            labels: ['1', '2'],
        }],
    'boxing': [{
            name: 'Maç Sonucu',
            pre: '637',
            live: '637',
            priority: 0,
            outcomeCount: 2,
            labels: ['1', '2'],
        }],
    'bikesmoto-gp': [{
            name: 'Maç Sonucu',
            pre: '637',
            live: '637',
            priority: 0,
            outcomeCount: 2,
            labels: ['1', '2'],
        }],
    'water-polo': [{
            name: 'Maç Sonucu',
            pre: '637',
            live: '637',
            priority: 0,
            outcomeCount: 2,
            labels: ['1', '2'],
        }],
    'esoccer': [
        {
            name: 'Maç Sonucu',
            pre: '1',
            live: '779',
            outcomeCount: 3,
            priority: 0,
            labels: ['1', '0', '2'],
        },
        {
            name: 'Alt/Üst 2,5',
            pre: '101-2.5',
            live: '780-2.5',
            outcomeCount: 2,
            priority: 1,
            labels: ['Üst', 'Alt'],
        },
        {
            name: 'Çifte Şans',
            pre: '92',
            live: '813',
            outcomeCount: 3,
            priority: 4,
            labels: ['1 ve 0', '1 ve 2', '0 ve 2'],
        },
        {
            name: 'Alt/Üst 1,5',
            pre: '101-1.5',
            live: '780-1.5',
            outcomeCount: 2,
            priority: 5,
            labels: ['Üst', 'Alt'],
        },
        {
            name: 'Alt/Üst 3,5',
            pre: '101-3.5',
            live: '780-3.5',
            outcomeCount: 2,
            priority: 6,
            labels: ['Üst', 'Alt'],
        },
        {
            name: 'İlk Yarı Alt/Üst 0.5',
            pre: '60-0.5',
            live: '784-0.5',
            outcomeCount: 2,
            priority: 7,
            labels: ['Üst', 'Alt'],
        },
        {
            name: 'İlk Yarı Alt/Üst 1.5',
            pre: '60-1.5',
            live: '784-1.5',
            outcomeCount: 2,
            priority: 8,
            labels: ['Üst', 'Alt'],
        },
        {
            name: 'İlk Yarı Sonucu',
            pre: '88',
            live: '783',
            outcomeCount: 3,
            priority: 9,
            labels: ['1', '0', '2'],
        },
    ],
    'ebasketball': [
        {
            name: 'Maç Sonucu',
            pre: '1',
            live: '786',
            outcomeCount: 2,
            priority: 0,
            labels: ['1', '2'],
        },
        {
            name: 'Toplam Alt/Üst',
            pre: '114',
            live: '787',
            priority: 0,
            outcomeCount: 2,
            labels: ['Üst', 'Alt'],
        },
        {
            name: 'İlk Yarı Sonucu',
            pre: '621',
            live: '785',
            priority: 0,
            outcomeCount: 3,
            labels: ['1', '0', '2'],
        },
        {
            name: 'İlk Yarı Toplam Alt/Üst',
            pre: '116',
            live: '824',
            priority: 0,
            outcomeCount: 2,
            labels: ['Alt', 'Üst']
        },
        // {
        //     name: 'İlk Çeyrek Sonucu',
        //     pre: '660',
        //     live: '673',
        //     priority: 0,
        //     outcomeCount: 3,
        //     labels: ['1', '0', '2'],
        // },
        {
            name: 'Ev Sahibi Alt/Üst',
            pre: '619',
            live: '826',
            priority: 0,
            outcomeCount: 2,
            labels: ['Alt', 'Üst']
        },
        {
            name: 'Deplasman Alt/Üst',
            pre: '620',
            live: '827',
            priority: 0,
            outcomeCount: 2,
            labels: ['Alt', 'Üst']
        }
    ],
    "futbol-canli": [
        {
            name: 'Maç Sonucu',
            pre: '1',
            live: '4',
            outcomeCount: 3,
            priority: 0,
            labels: ['1', '0', '2'],
            firstPeriod: '47',
            specialOddsValue: false,
        },
        {
            name: 'Alt/Üst 2,5',
            pre: '101-2.5',
            live: '14-2.5',
            outcomeCount: 2,
            priority: 1,
            labels: ['Üst', 'Alt'],
            firstPeriod: '63-2.5',
            specialOddsValue: true,
        },
        {
            name: 'Maçın Geri Kalanını Kim Kazanır',
            pre: '23',
            live: '23',
            outcomeCount: 3,
            priority: 2,
            specialOddsValue: false,
            labels: ['1', '0', '2'],
        },
        {
            name: 'Sıradaki Gol',
            pre: '34',
            live: '34',
            outcomeCount: 3,
            priority: 3,
            labels: ['1', '0', '2'],
            specialOddsValue: false,
        },
        {
            name: 'Karşılıklı Gol',
            pre: '5508',
            live: '5508',
            outcomeCount: 2,
            priority: 2,
            labels: ['Var', 'Yok'],
            firstPeriod: '735',
            specialOddsValue: false,
        },
        // {
        //   name: 'Handikaplı Maç Sonucu',
        //   pre: '100',
        //   live: '12',
        //   outcomeCount: 3,
        //   priority: 3
        // },
        {
            name: 'Çifte Şans',
            pre: '92',
            live: '129',
            outcomeCount: 3,
            priority: 4,
            labels: ['1 ve 0', '1 ve 2', '0 ve 2'],
            firstPeriod: '625',
            specialOddsValue: false,
        },
        {
            name: 'Alt/Üst 1,5',
            pre: '101-1.5',
            live: '14-1.5',
            outcomeCount: 2,
            priority: 5,
            labels: ['Üst', 'Alt'],
            firstPeriod: '63-1.5',
            specialOddsValue: true,
        },
        {
            name: 'Alt/Üst 3,5',
            pre: '101-3.5',
            live: '14-3.5',
            outcomeCount: 2,
            priority: 6,
            labels: ['Üst', 'Alt'],
            firstPeriod: '63-3.5',
            specialOddsValue: true,
        },
        {
            name: 'İlk Yarı Alt/Üst 0.5',
            pre: '60-0.5',
            live: '63-0.5',
            outcomeCount: 2,
            priority: 7,
            labels: ['Üst', 'Alt'],
            specialOddsValue: true,
        },
        {
            name: 'İlk Yarı Alt/Üst 1.5',
            pre: '60-1.5',
            live: '63-1.5',
            outcomeCount: 2,
            priority: 8,
            labels: ['Üst', 'Alt'],
            specialOddsValue: true,
        },
        {
            name: 'İlk Yarı Sonucu',
            pre: '88',
            outcomeCount: 3,
            priority: 9,
            labels: ['1', '0', '2'],
            specialOddsValue: true,
        },
        // {
        //   name: 'Toplam Gol',
        //   pre: '4',
        //   live: '4',
        //   outcomeCount: 4,
        //   priority: 10
        // }
    ],
    "duello-canli": [
        {
            name: 'Maç Sonucu',
            pre: '770',
            live: '770',
            outcomeCount: 3,
            priority: 0,
            labels: ['1', '0', '2'],
        },
        {
            name: 'Toplam Alt/Üst',
            pre: '772',
            live: '772',
            outcomeCount: 2,
            priority: 1,
            labels: ['Üst', 'Alt'],
        },
    ],
    "soccer-canli": [
        {
            name: 'Maç Sonucu',
            pre: '1',
            live: '4',
            outcomeCount: 3,
            priority: 0,
            labels: ['1', '0', '2'],
        },
        // {
        //   name: 'Toplam Alt/Üst',
        //   pre: '101',
        //   live: '14',
        //   outcomeCount: 2,
        //   priority: 1
        // },
        {
            name: 'Alt/Üst 2,5',
            pre: '101-2.5',
            live: '14-2.5',
            outcomeCount: 2,
            priority: 1,
            labels: ['Üst', 'Alt'],
        },
        {
            name: 'Karşılıklı Gol',
            pre: '5508',
            live: '5508',
            outcomeCount: 2,
            priority: 2,
            labels: ['Var', 'Yok'],
        },
        // {
        //   name: 'Handikaplı Maç Sonucu',
        //   pre: '100',
        //   live: '12',
        //   outcomeCount: 3,
        //   priority: 3
        // },
        {
            name: 'Çifte Şans',
            pre: '92',
            live: '129',
            outcomeCount: 3,
            priority: 4,
            labels: ['1 ve 0', '1 ve 2', '0 ve 2'],
        },
        {
            name: 'Alt/Üst 1,5',
            pre: '101-1.5',
            live: '14-1.5',
            outcomeCount: 2,
            priority: 5,
            labels: ['Üst', 'Alt'],
        },
        {
            name: 'Alt/Üst 3,5',
            pre: '101-3.5',
            live: '14-3.5',
            outcomeCount: 2,
            priority: 6,
            labels: ['Üst', 'Alt'],
        },
        {
            name: 'İlk Yarı Alt/Üst 0.5',
            pre: '60-0.5',
            live: '63-0.5',
            outcomeCount: 2,
            priority: 7,
            labels: ['Üst', 'Alt'],
        },
        {
            name: 'İlk Yarı Alt/Üst 1.5',
            pre: '60-1.5',
            live: '63-1.5',
            outcomeCount: 2,
            priority: 8,
            labels: ['Üst', 'Alt'],
        },
        {
            name: 'İlk Yarı Sonucu',
            pre: '88',
            live: '47',
            outcomeCount: 3,
            priority: 9,
            labels: ['1', '0', '2'],
        },
        // {
        //   name: 'Toplam Gol',
        //   pre: '4',
        //   live: '4',
        //   outcomeCount: 4,
        //   priority: 10
        // }
    ],
    "basketbol-canli": [
        {
            name: 'Maç Sonucu',
            pre: '2',
            live: '71',
            priority: 0,
            outcomeCount: 2,
            labels: ['1', '2'],
        },
        {
            name: 'Toplam Alt/Üst',
            pre: '4478',
            live: '4478',
            priority: 0,
            outcomeCount: 2,
            labels: ['Üst', 'Alt'],
        },
        // {
        //   name: 'H. Maç Sonucu',
        //   pre: '113',
        //   live: '286',
        //   priority: 0,
        //   outcomeCount: 2
        // },
        {
            name: 'İlk Yarı Sonucu',
            pre: '621',
            live: '606',
            priority: 0,
            outcomeCount: 3,
            labels: ['1', '0', '2'],
        },
        {
            name: 'İlk Yarı Toplam Alt/Üst',
            pre: '116',
            live: '64',
            priority: 0,
            outcomeCount: 2,
            labels: ['Alt', 'Üst']
        },
        // {
        //   name: 'İlk Yarı Handikaplı Sonucu',
        //   pre: '115',
        //   live: '115',
        //   priority: 0,
        //   outcomeCount: 2
        // },
        {
            name: 'İlk Çeyrek Sonucu',
            pre: '660',
            live: '673',
            priority: 0,
            outcomeCount: 3,
            labels: ['1', '0', '2'],
        },
        {
            name: 'Ev Sahibi Alt/Üst',
            pre: '619',
            live: '615',
            priority: 0,
            outcomeCount: 2,
            labels: ['Alt', 'Üst']
        },
        {
            name: 'Deplasman Alt/Üst',
            pre: '620',
            live: '616',
            priority: 0,
            outcomeCount: 2,
            labels: ['Alt', 'Üst']
        }
    ],
    "basketball-canli": [
        {
            name: 'Maç Sonucu',
            pre: "4476",
            live: "4476",
            priority: 0,
            outcomeCount: 2,
            labels: ['1', '2'],
        },
        {
            name: 'Toplam Alt/Üst',
            pre: '4478',
            live: '4478',
            priority: 0,
            outcomeCount: 2,
            labels: ['Üst', 'Alt'],
        },
        // {
        //   name: 'H. Maç Sonucu',
        //   pre: '113',
        //   live: '286',
        //   priority: 0,
        //   outcomeCount: 2
        // },
        {
            name: 'İlk Yarı Sonucu',
            pre: '621',
            live: '606',
            priority: 0,
            outcomeCount: 3,
            labels: ['1', '0', '2'],
        },
        {
            name: 'İlk Yarı Toplam Alt/Üst',
            pre: '116',
            live: '64',
            priority: 0,
            outcomeCount: 2,
            labels: ['Alt', 'Üst']
        },
        // {
        //   name: 'İlk Yarı Handikaplı Sonucu',
        //   pre: '115',
        //   live: '115',
        //   priority: 0,
        //   outcomeCount: 2
        // },
        {
            name: 'İlk Çeyrek Sonucu',
            pre: '660',
            live: '673',
            priority: 0,
            outcomeCount: 3,
            labels: ['1', '0', '2'],
        },
        {
            name: 'Ev Sahibi Alt/Üst',
            pre: '619',
            live: '615',
            priority: 0,
            outcomeCount: 2,
            labels: ['Alt', 'Üst']
        },
        {
            name: 'Deplasman Alt/Üst',
            pre: '620',
            live: '616',
            priority: 0,
            outcomeCount: 2,
            labels: ['Alt', 'Üst']
        }
    ],
    "basket-canli": [
        {
            name: 'Maç Sonucu',
            pre: '2',
            live: '71',
            priority: 0,
            outcomeCount: 2,
            labels: ['1', '2'],
        },
        {
            name: 'Toplam Alt/Üst',
            pre: '114',
            live: '140',
            priority: 0,
            outcomeCount: 2,
            labels: ['Üst', 'Alt'],
        },
        // {
        //   name: 'H. Maç Sonucu',
        //   pre: '113',
        //   live: '286',
        //   priority: 0,
        //   outcomeCount: 2
        // },
        {
            name: 'İlk Yarı Sonucu',
            pre: '621',
            live: '606',
            priority: 0,
            outcomeCount: 3,
            labels: ['1', '0', '2'],
        },
        {
            name: 'İlk Yarı Toplam Alt/Üst',
            pre: '116',
            live: '64',
            priority: 0,
            outcomeCount: 2,
            labels: ['Alt', 'Üst']
        },
        // {
        //   name: 'İlk Yarı Handikaplı Sonucu',
        //   pre: '115',
        //   live: '115',
        //   priority: 0,
        //   outcomeCount: 2
        // },
        {
            name: 'İlk Çeyrek Sonucu',
            pre: '660',
            live: '673',
            priority: 0,
            outcomeCount: 3,
            labels: ['1', '0', '2'],
        },
        {
            name: 'Ev Sahibi Alt/Üst',
            pre: '619',
            live: '615',
            priority: 0,
            outcomeCount: 2,
            labels: ['Alt', 'Üst']
        },
        {
            name: 'Deplasman Alt/Üst',
            pre: '620',
            live: '616',
            priority: 0,
            outcomeCount: 2,
            labels: ['Alt', 'Üst']
        }
    ],
    "tenis-canli": [
        {
            name: 'Maç Sonucu',
            pre: '9',
            live: '56',
            priority: 0,
            outcomeCount: 2,
            labels: ['1', '2']
        },
        {
            name: 'Toplam Oyun Alt/Üst',
            pre: '168',
            live: '191',
            priority: 0,
            outcomeCount: 2,
            labels: ['Alt', 'Üst']
        },
        // {
        //   name: 'Handikaplı Maç Sonucu',
        //   pre: '649',
        //   live: '613',
        //   priority: 0,
        //   outcomeCount: 2
        // },
        {
            name: '1. Oyuncu Set Kazanır',
            pre: '647',
            live: '607',
            priority: 0,
            outcomeCount: 2,
            labels: ['Evet', 'Hayır'],
        },
        {
            name: '2. Oyuncu Set Kazanır',
            pre: '648',
            live: '608',
            priority: 0,
            outcomeCount: 2,
            labels: ['Evet', 'Hayır'],
        },
        {
            name: '1. Oyuncu Alt/Üst',
            pre: '650',
            live: '622',
            priority: 0,
            outcomeCount: 2,
            labels: ['Üst', 'Alt'],
        },
        {
            name: '2. Oyuncu Alt/Üst',
            pre: '651',
            live: '623',
            priority: 0,
            outcomeCount: 2,
            labels: ['Üst', 'Alt'],
        }
    ],
    "tennis-canli": [
        {
            name: 'Maç Sonucu',
            pre: '2434',
            live: '2434',
            priority: 0,
            outcomeCount: 2,
            labels: ['1', '2'],
        },
        {
            name: 'Toplam Oyun Alt/Üst',
            pre: '168',
            live: '191',
            priority: 0,
            outcomeCount: 2,
            labels: ['Üst', 'Alt'],
        },
        // {
        //   name: 'Handikaplı Maç Sonucu',
        //   pre: '649',
        //   live: '613',
        //   priority: 0,
        //   outcomeCount: 2
        // },
        {
            name: '1. Oyuncu Set Kazanır',
            pre: '647',
            live: '607',
            priority: 0,
            outcomeCount: 2,
            labels: ['Evet', 'Hayır'],
        },
        {
            name: '2. Oyuncu Set Kazanır',
            pre: '648',
            live: '608',
            priority: 0,
            outcomeCount: 2,
            labels: ['Evet', 'Hayır'],
        },
        {
            name: '1. Oyuncu Alt/Üst',
            pre: '650',
            live: '622',
            priority: 0,
            outcomeCount: 2,
            labels: ['Üst', 'Alt'],
        },
        {
            name: '2. Oyuncu Alt/Üst',
            pre: '651',
            live: '623',
            priority: 0,
            outcomeCount: 2,
            labels: ['Üst', 'Alt'],
        }
    ],
    'masa-tenisi-canli': [
        {
            name: 'Maç Sonucu',
            pre: '633',
            live: '653',
            priority: 0,
            outcomeCount: 2,
            labels: ['1', '2'],
        }
    ],
    'table-tennis-canli': [
        {
            name: 'Maç Sonucu',
            pre: '633',
            live: '653',
            priority: 0,
            outcomeCount: 2,
            labels: ['1', '2'],
        }
    ],
    'buz-hokeyi-canli': [
        {
            name: 'Maç Sonucu',
            pre: '21',
            live: '653',
            priority: 0,
            outcomeCount: 3,
            labels: ['1', '0', '2'],
        },
        {
            name: 'Toplam Gol Alt/Üst',
            pre: '164',
            live: '21',
            priority: 0,
            outcomeCount: 2,
            labels: ['Üst', 'Alt'],
        },
        // {
        //   name: 'Handikaplı Maç Sonucu',
        //   pre: '163',
        //   live: '9',
        //   priority: 0,
        //   outcomeCount: 3
        // },
        {
            name: 'Çifte Şans',
            pre: '159',
            live: '128',
            priority: 0,
            outcomeCount: 3,
            labels: ['1 ve 0', '1 ve 2', '0 ve 2'],
        }
    ],
    'ice-hockey-canli': [
        {
            name: 'Maç Sonucu',
            pre: '21',
            live: '653',
            priority: 0,
            outcomeCount: 3,
            labels: ['1', '0', '2'],
        },
        {
            name: 'Toplam Gol Alt/Üst',
            pre: '164',
            live: '21',
            priority: 0,
            outcomeCount: 2,
            labels: ['Üst', 'Alt'],
        },
        // {
        //   name: 'Handikaplı Maç Sonucu',
        //   pre: '163',
        //   live: '9',
        //   priority: 0,
        //   outcomeCount: 3
        // },
        {
            name: 'Çifte Şans',
            pre: '159',
            live: '128',
            priority: 0,
            outcomeCount: 3,
            labels: ['1 ve 0', '1 ve 2', '0 ve 2'],
        }
    ],
    "voleybol-canli": [
        {
            name: 'Maç Sonucu',
            pre: '10',
            live: '114',
            priority: 0,
            outcomeCount: 2,
            labels: ['1', '2'],
        },
        {
            name: 'Toplam Sayı Alt/Üst',
            pre: '217',
            live: '18',
            priority: 0,
            outcomeCount: 2,
            labels: ['Üst', 'Alt'],
        },
        // {
        //   name: 'Handikaplı Maç Sonucu',
        //   pre: '231',
        //   live: '239',
        //   priority: 0,
        //   outcomeCount: 2
        // }
    ],
    "hentbol-canli": [
        {
            name: 'Maç Sonucu',
            pre: '16',
            live: '3',
            priority: 0,
            outcomeCount: 3,
            labels: ['1', '0', '2'],
        },
        {
            name: 'Toplam Gol Alt/Üst',
            pre: '191',
            live: '20',
            priority: 0,
            outcomeCount: 2,
            labels: ['Üst', 'Alt'],
        },
        // {
        //   name: 'Handikaplı Maç Sonucu',
        //   pre: '187',
        //   live: '187',
        //   priority: 0,
        //   outcomeCount: 2
        // },
        {
            name: 'Çifte Şans',
            pre: '185',
            live: '633',
            priority: 0,
            outcomeCount: 3,
            labels: ['1 ve 0', '1 ve 2', '0 ve 2'],
        }
    ],
    "handball-canli": [
        {
            name: 'Maç Sonucu',
            pre: '16',
            live: '3',
            priority: 0,
            outcomeCount: 3,
            labels: ['1', '0', '2'],
        },
        {
            name: 'Toplam Gol Alt/Üst',
            pre: '191',
            live: '20',
            priority: 0,
            outcomeCount: 2,
            labels: ['Üst', 'Alt'],
        },
        // {
        //   name: 'Handikaplı Maç Sonucu',
        //   pre: '187',
        //   live: '187',
        //   priority: 0,
        //   outcomeCount: 2
        // },
        {
            name: 'Çifte Şans',
            pre: '185',
            live: '633',
            priority: 0,
            outcomeCount: 3,
            labels: ['1 ve 0', '1 ve 2', '0 ve 2'],
        }
    ],
    "snooker-canli": [
        {
            name: 'Maç Sonucu',
            pre: '15',
            live: '600',
            priority: 0,
            outcomeCount: 2,
            labels: ['1', '2'],
        },
        {
            name: 'Toplam Frame Alt/Üst',
            pre: '642',
            live: '602',
            priority: 0,
            outcomeCount: 2,
            labels: ['Üst', 'Alt'],
        },
        // {
        //   name: 'Handikaplı Maç Sonucu',
        //   pre: '641',
        //   live: '641',
        //   priority: 0,
        //   outcomeCount: 2
        // }
    ],
    'motor-sporlar-canli': [
        {
            name: 'Tümü',
            pre: '3-1',
            live: '600',
            priority: 0,
            outcomeCount: 2,
            labels: ['1', '2']
        },
    ],
    "mma-canli": [
        {
            name: 'Maç Sonucu',
            pre: '637',
            live: '637',
            priority: 0,
            outcomeCount: 2,
            labels: ['1', '2'],
        }
    ],
    "valorant": [
        {
            name: 'Maç Sonucu',
            pre: '637',
            live: '637',
            priority: 0,
            outcomeCount: 2,
            labels: ['1', '2'],
        }
    ],
    "valorant-canli": [
        {
            name: 'Maç Sonucu',
            pre: '637',
            live: '637',
            priority: 0,
            outcomeCount: 2,
            labels: ['1', '2'],
        }
    ],
    'aussie-rules-canli': [{
            name: 'Maç Sonucu',
            pre: '637',
            live: '637',
            priority: 0,
            outcomeCount: 2,
            labels: ['1', '2'],
        }],
    'cycling-canli': [{
            name: 'Maç Sonucu',
            pre: '637',
            live: '637',
            priority: 0,
            outcomeCount: 2,
            labels: ['1', '2'],
        }],
    'boxing-canli': [{
            name: 'Maç Sonucu',
            pre: '637',
            live: '637',
            priority: 0,
            outcomeCount: 2,
            labels: ['1', '2'],
        }],
    'bikesmoto-gp-canli': [{
            name: 'Maç Sonucu',
            pre: '637',
            live: '637',
            priority: 0,
            outcomeCount: 2,
            labels: ['1', '2'],
        }],
    'water-polo-canli': [{
            name: 'Maç Sonucu',
            pre: '637',
            live: '637',
            priority: 0,
            outcomeCount: 2,
            labels: ['1', '2'],
        }],
    'esoccer-canli': [
        {
            name: 'Maç Sonucu',
            pre: '1',
            live: '779',
            outcomeCount: 3,
            priority: 0,
            labels: ['1', '0', '2'],
        },
        {
            name: 'Alt/Üst 2,5',
            pre: '101-2.5',
            live: '780-2.5',
            outcomeCount: 2,
            priority: 1,
            labels: ['Üst', 'Alt'],
        },
        {
            name: 'Çifte Şans',
            pre: '92',
            live: '813',
            outcomeCount: 3,
            priority: 4,
            labels: ['1 ve 0', '1 ve 2', '0 ve 2'],
        },
        {
            name: 'Alt/Üst 1,5',
            pre: '101-1.5',
            live: '780-1.5',
            outcomeCount: 2,
            priority: 5,
            labels: ['Üst', 'Alt'],
        },
        {
            name: 'Alt/Üst 3,5',
            pre: '101-3.5',
            live: '780-3.5',
            outcomeCount: 2,
            priority: 6,
            labels: ['Üst', 'Alt'],
        },
        {
            name: 'İlk Yarı Alt/Üst 0.5',
            pre: '60-0.5',
            live: '784-0.5',
            outcomeCount: 2,
            priority: 7,
            labels: ['Üst', 'Alt'],
        },
        {
            name: 'İlk Yarı Alt/Üst 1.5',
            pre: '60-1.5',
            live: '784-1.5',
            outcomeCount: 2,
            priority: 8,
            labels: ['Üst', 'Alt'],
        },
        {
            name: 'İlk Yarı Sonucu',
            pre: '88',
            live: '783',
            outcomeCount: 3,
            priority: 9,
            labels: ['1', '0', '2'],
        },
    ],
    'ebasketball-canli': [
        {
            name: 'Maç Sonucu',
            pre: '1',
            live: '786',
            outcomeCount: 2,
            priority: 0,
            labels: ['1', '2'],
        },
        {
            name: 'Toplam Alt/Üst',
            pre: '114',
            live: '787',
            priority: 0,
            outcomeCount: 2,
            labels: ['Üst', 'Alt'],
        },
        {
            name: 'İlk Yarı Sonucu',
            pre: '621',
            live: '785',
            priority: 0,
            outcomeCount: 3,
            labels: ['1', '0', '2'],
        },
        {
            name: 'İlk Yarı Toplam Alt/Üst',
            pre: '116',
            live: '824',
            priority: 0,
            outcomeCount: 2,
            labels: ['Alt', 'Üst']
        },
        // {
        //     name: 'İlk Çeyrek Sonucu',
        //     pre: '660',
        //     live: '673',
        //     priority: 0,
        //     outcomeCount: 3,
        //     labels: ['1', '0', '2'],
        // },
        {
            name: 'Ev Sahibi Alt/Üst',
            pre: '619',
            live: '826',
            priority: 0,
            outcomeCount: 2,
            labels: ['Alt', 'Üst']
        },
        {
            name: 'Deplasman Alt/Üst',
            pre: '620',
            live: '827',
            priority: 0,
            outcomeCount: 2,
            labels: ['Alt', 'Üst']
        }
    ],
    "golf-canli": [
        {
            name: 'Maç Sonucu',
            pre: '637',
            live: '637',
            priority: 0,
            outcomeCount: 2,
            labels: ['1', '2'],
        }
    ],
    "curling-canli": [
        {
            name: 'Maç Sonucu',
            pre: '637',
            live: '637',
            priority: 0,
            outcomeCount: 2,
            labels: ['1', '2'],
        }
    ],
    "rugby-union-canli": [
        {
            name: 'Maç Sonucu',
            pre: '637',
            live: '637',
            priority: 0,
            outcomeCount: 2,
            labels: ['1', '2'],
        }
    ],
    "baseball-canli": [
        {
            name: 'Maç Sonucu',
            pre: '637',
            live: '637',
            priority: 0,
            outcomeCount: 2,
            labels: ['1', '2'],
        }
    ],
    "floorball-canli": [
        {
            name: 'Maç Sonucu',
            pre: '637',
            live: '637',
            priority: 0,
            outcomeCount: 2,
            labels: ['1', '2'],
        }
    ],
    "futsal-canli": [
        {
            name: 'Maç Sonucu',
            pre: '637',
            live: '637',
            priority: 0,
            outcomeCount: 2,
            labels: ['1', '2'],
        }
    ],
    "dota-2-canli": [
        {
            name: 'Maç Sonucu',
            pre: '637',
            live: '637',
            priority: 0,
            outcomeCount: 2,
            labels: ['1', '2'],
        }
    ],
    "counter-strike-2": [
        {
            name: 'Maç Sonucu',
            pre: '637',
            live: '637',
            priority: 0,
            outcomeCount: 2,
            labels: ['1', '2'],
        }
    ],
    "counter-strike-2-canli": [
        {
            name: 'Maç Sonucu',
            pre: '637',
            live: '637',
            priority: 0,
            outcomeCount: 2,
            labels: ['1', '2'],
        }
    ],
    "league-of-legends-canli": [
        {
            name: 'Maç Sonucu',
            pre: '637',
            live: '637',
            priority: 0,
            outcomeCount: 2,
            labels: ['1', '2'],
        }
    ],
    "badminton-canli": [
        {
            name: 'Maç Sonucu',
            pre: '637',
            live: '637',
            priority: 0,
            outcomeCount: 2,
            labels: ['1', '2'],
        }
    ],
    "volleyball-canli": [
        {
            name: 'Maç Sonucu',
            pre: '399',
            live: '399',
            priority: 0,
            outcomeCount: 2,
            labels: ['1', '2'],
        },
        {
            name: 'Toplam Sayı Alt/Üst',
            pre: '217',
            live: '18',
            priority: 0,
            outcomeCount: 2,
            labels: ['Üst', 'Alt'],
        },
        // {
        //   name: 'Handikaplı Maç Sonucu',
        //   pre: '231',
        //   live: '239',
        //   priority: 0,
        //   outcomeCount: 2
        // }
    ],
    "american-football": [{
            name: 'Maç Sonucu',
            pre: '10',
            live: '114',
            priority: 0,
            outcomeCount: 2,
            labels: ['1', '2'],
        },],
    "american-football-canli": [{
            name: 'Maç Sonucu',
            pre: '10',
            live: '114',
            priority: 0,
            outcomeCount: 2,
            labels: ['1', '2'],
        },],
    "rainbow-six": [{
            name: 'Maç Sonucu',
            pre: '10',
            live: '114',
            priority: 0,
            outcomeCount: 2,
            labels: ['1', '2'],
        },],
    "rainbow-six-canli": [{
            name: 'Maç Sonucu',
            pre: '10',
            live: '114',
            priority: 0,
            outcomeCount: 2,
            labels: ['1', '2'],
        },],
    "crossfire": [{
            name: 'Maç Sonucu',
            pre: '10',
            live: '114',
            priority: 0,
            outcomeCount: 2,
            labels: ['1', '2'],
        },],
    "crossfire-canli": [{
            name: 'Maç Sonucu',
            pre: '10',
            live: '114',
            priority: 0,
            outcomeCount: 2,
            labels: ['1', '2'],
        },],
    "pickleball": [{
            name: 'Maç Sonucu',
            pre: '10',
            live: '114',
            priority: 0,
            outcomeCount: 2,
            labels: ['1', '2'],
        },],
    "pickleball-canli": [{
            name: 'Maç Sonucu',
            pre: '10',
            live: '114',
            priority: 0,
            outcomeCount: 2,
            labels: ['1', '2'],
        },],
    "starcraft-2": [{
            name: 'Maç Sonucu',
            pre: '10',
            live: '114',
            priority: 0,
            outcomeCount: 2,
            labels: ['1', '2'],
        },],
    "starcraft-2-canli": [{
            name: 'Maç Sonucu',
            pre: '10',
            live: '114',
            priority: 0,
            outcomeCount: 2,
            labels: ['1', '2'],
        },],
    "netball": [{
            name: 'Maç Sonucu',
            pre: '10',
            live: '114',
            priority: 0,
            outcomeCount: 2,
            labels: ['1', '2'],
        },],
    "netball-canli": [{
            name: 'Maç Sonucu',
            pre: '10',
            live: '114',
            priority: 0,
            outcomeCount: 2,
            labels: ['1', '2'],
        },],
    "skateboarding": [{
            name: 'Maç Sonucu',
            pre: '10',
            live: '114',
            priority: 0,
            outcomeCount: 2,
            labels: ['1', '2'],
        },],
    "skateboarding-canli": [{
            name: 'Maç Sonucu',
            pre: '10',
            live: '114',
            priority: 0,
            outcomeCount: 2,
            labels: ['1', '2'],
        },],
    "eurovision": [{
            name: 'Maç Sonucu',
            pre: '10',
            live: '114',
            priority: 0,
            outcomeCount: 2,
            labels: ['1', '2'],
        },],
    "eurovision-canli": [{
            name: 'Maç Sonucu',
            pre: '10',
            live: '114',
            priority: 0,
            outcomeCount: 2,
            labels: ['1', '2'],
        },],
    "special-bets": [{
            name: 'Maç Sonucu',
            pre: '10',
            live: '114',
            priority: 0,
            outcomeCount: 2,
            labels: ['1', '2'],
        },],
    "special-bets-canli": [{
            name: 'Maç Sonucu',
            pre: '10',
            live: '114',
            priority: 0,
            outcomeCount: 2,
            labels: ['1', '2'],
        },],
    "nascar": [{
            name: 'Maç Sonucu',
            pre: '10',
            live: '114',
            priority: 0,
            outcomeCount: 2,
            labels: ['1', '2'],
        },],
    "nascar-canli": [{
            name: 'Maç Sonucu',
            pre: '10',
            live: '114',
            priority: 0,
            outcomeCount: 2,
            labels: ['1', '2'],
        },],
    "gaelic-football": [{
            name: 'Maç Sonucu',
            pre: '10',
            live: '114',
            priority: 0,
            outcomeCount: 2,
            labels: ['1', '2'],
        },],
    "gaelic-football-canli": [{
            name: 'Maç Sonucu',
            pre: '10',
            live: '114',
            priority: 0,
            outcomeCount: 2,
            labels: ['1', '2'],
        },],
    "surfing": [{
            name: 'Maç Sonucu',
            pre: '10',
            live: '114',
            priority: 0,
            outcomeCount: 2,
            labels: ['1', '2'],
        },],
    "surfing-canli": [{
            name: 'Maç Sonucu',
            pre: '10',
            live: '114',
            priority: 0,
            outcomeCount: 2,
            labels: ['1', '2'],
        },],
    "mobile-legends": [{
            name: 'Maç Sonucu',
            pre: '10',
            live: '114',
            priority: 0,
            outcomeCount: 2,
            labels: ['1', '2'],
        },],
    "mobile-legends-canli": [{
            name: 'Maç Sonucu',
            pre: '10',
            live: '114',
            priority: 0,
            outcomeCount: 2,
            labels: ['1', '2'],
        },],
    "speedway": [{
            name: 'Maç Sonucu',
            pre: '10',
            live: '114',
            priority: 0,
            outcomeCount: 2,
            labels: ['1', '2'],
        },],
    "speedway-canli": [{
            name: 'Maç Sonucu',
            pre: '10',
            live: '114',
            priority: 0,
            outcomeCount: 2,
            labels: ['1', '2'],
        },],
    "king-of-glory": [{
            name: 'Maç Sonucu',
            pre: '10',
            live: '114',
            priority: 0,
            outcomeCount: 2,
            labels: ['1', '2'],
        },],
    "king-of-glory-canli": [{
            name: 'Maç Sonucu',
            pre: '10',
            live: '114',
            priority: 0,
            outcomeCount: 2,
            labels: ['1', '2'],
        },],
    "3x3-basketball": [{
            name: 'Maç Sonucu',
            pre: '10',
            live: '114',
            priority: 0,
            outcomeCount: 2,
            labels: ['1', '2'],
        },],
    "3x3-basketball-canli": [{
            name: 'Maç Sonucu',
            pre: '10',
            live: '114',
            priority: 0,
            outcomeCount: 2,
            labels: ['1', '2'],
        },],
    "rugby-league": [{
            name: 'Maç Sonucu',
            pre: '10',
            live: '114',
            priority: 0,
            outcomeCount: 2,
            labels: ['1', '2'],
        },],
    "rugby-league-canli": [{
            name: 'Maç Sonucu',
            pre: '10',
            live: '114',
            priority: 0,
            outcomeCount: 2,
            labels: ['1', '2'],
        },],
    "ski-jumping": [{
            name: 'Maç Sonucu',
            pre: '10',
            live: '114',
            priority: 0,
            outcomeCount: 2,
            labels: ['1', '2'],
        },],
    "ski-jumping-canli": [{
            name: 'Maç Sonucu',
            pre: '10',
            live: '114',
            priority: 0,
            outcomeCount: 2,
            labels: ['1', '2'],
        },],
};
export var handicappedMarkets = ["712", '100', '12', '113', '286', '115', '649', '613', '641', '187', '231', '239', '163', '9', '161'];
export var newMarkets = [
    "728",
    "731",
    "732",
    "733",
    "734",
    "735",
    "736",
    "737",
    "738",
    "707",
    "739",
    "708",
    "709",
    "740",
    "712",
    "717",
    "673",
    "750",
    "751",
    "752",
    "742",
    "747",
    "748",
    "749",
    "724",
    "717",
    "700",
    "727",
    "728",
    "720",
    "56",
    "722",
    "723",
    "724",
    "698",
    "699",
    "725",
    "702",
    "707",
    "660",
    "755",
    "756",
    "757",
    "746",
    "747",
    "749",
    "758",
    "759",
    "760",
    "711",
    "712",
    "714",
    "737",
    "727",
    "718",
    "719",
    "729",
    "730",
    "731",
    "732",
    "733",
    "734",
    "735",
    "736",
    "748",
    "750",
    "769",
    "768",
    "701",
    "703",
    "704",
    "705",
    "709",
    "710",
    "711",
    "713",
    "714",
    "715",
    "718",
    "743",
    "744",
    "745",
    "746",
    "719",
    "720",
    "767",
];
export var rapidMarkets = [
    "759",
    "760",
    "761",
    "762",
    "763",
    "764",
    "765",
    "766"
];
export var marketCategories = {
    "futbol": [
        {
            name: "Tümü",
            betCategory: 1,
            markets: [],
            marketObjects: {}
        },
        {
            name: "Maç",
            betCategory: 4,
            markets: [
                "1",
                "4",
                "100",
                "12",
                "7",
                "643",
                "644",
                "69",
                "72",
                "92",
                "129",
                "11",
                "42",
                "90",
                "23",
                "36",
                "321",
                "27"
            ],
            marketObjects: {}
        },
        {
            name: "Toplamlar",
            betCategory: 5,
            markets: [
                "87",
                "7",
                "101",
                "14",
                "89",
                "131",
                "4",
                "603",
                "203",
                "604",
                "207",
                "45",
                "6",
                "199",
                "84",
                "85",
                "43",
                "44",
                "91",
                "136",
                "34",
                "54"
            ],
            marketObjects: {}
        },
        {
            "name": "Yarılar",
            "betCategory": 6,
            "markets": [
                "88",
                "47",
                "60",
                "63",
                "6",
                "199",
                "84",
                "85",
                "77",
                "625"
            ], marketObjects: {}
        },
        {
            "name": "Korner",
            "betCategory": 7,
            "markets": [
                "48",
                "49",
                "52",
                "53",
                "56",
                "67",
                "68",
                "210",
                "211",
                "215",
                "217",
                "218",
                "222"
            ],
            marketObjects: {}
        },
        {
            "name": "Özel",
            "betCategory": 8,
            "markets": [
                "10",
                "17",
                "86",
                "252",
                "27",
                "54",
                "801",
                "802",
                "803",
                "804",
                "800",
                "658",
                "12",
                "661",
                "3"
            ],
            marketObjects: {}
        }
    ],
    "football": [
        {
            name: "Tümü",
            betCategory: 1,
            markets: [],
            marketObjects: {}
        },
        {
            name: "Maç",
            betCategory: 4,
            markets: [],
            marketObjects: {}
        },
        {
            name: "Toplamlar",
            betCategory: 5,
            markets: [
                "11559",
                "6499",
                "9022",
                "11605",
                "11536",
                "5516",
                "5500",
                "11285",
                "5501",
                "11547",
                "11285",
                "11214",
                "15153",
                "9018",
                "5502",
                "8725",
                "8725",
                "5520",
                "11285",
                "10132",
                "5500",
                "11285",
                "8725",
                "11611",
                "5500",
                "11023",
                "11011",
                "5511",
                "11284",
                "11601",
                "11537",
                "11602",
                "5520",
                "5501",
                "11382",
                "10047",
                "11609",
                "11056",
                "11604",
                "10377",
                "10047",
                "11536",
                "7648",
                "11027",
                "5520",
                "5500",
                "14052",
                "5513",
                "11550",
                "6498",
                "11598",
                "11611",
                "10047",
                "5500",
                "6498",
                "11214",
                "8725",
                "9022",
                "11604",
                "8720",
                "8725",
                "14052",
                "11011",
                "11601",
                "5500",
                "11023",
                "7642",
                "5502",
                "6502",
                "11611",
                "5512",
                "5520",
                "11596",
                "11551",
                "11284",
                "14052",
                "11011",
                "5502",
                "5502",
                "11011",
                "11549",
                "6498",
                "10591",
                "11537",
                "5520",
                "10047",
                "9024",
                "6507",
                "6507",
                "5500",
                "11284",
                "5520",
                "11544",
                "11536",
                "10047",
                "5500",
                "11602",
                "8725",
                "9020",
                "11285",
                "5500",
                "11537",
                "6499",
                "5514",
                "5502",
                "15155",
                "11011",
                "11381",
                "5501",
                "6499",
                "11381",
                "5500",
                "11599",
                "5500",
                "7643",
                "11548",
                "11595",
                "11546",
                "5520",
                "11211",
                "10839",
                "9018",
                "14052",
                "8720",
                "5501",
                "11027",
                "9904",
                "9903",
                "5517",
                "8720",
                "11598",
                "10047",
                "14595",
                "11284",
                "14298",
                "10047",
                "6517",
                "6509",
                "11383",
                "6517",
                "11536",
                "6509",
                "13377",
                "14298",
                "8720",
                "14299",
                "13377",
                "11537",
                "5500",
                "11011",
                "9903",
                "6518",
                "11023",
                "6508",
                "14052",
                "6507",
                "9904",
                "11284",
                "6519",
                "8725",
                "6507",
                "11381",
                "8720",
                "6508",
                "6508",
                "11382",
                "11605",
                "8725",
                "9024",
                "5501",
                "6507",
                "6507",
                "6508",
                "6509",
                "6518",
                "10047",
                "6507",
                "8720",
                "14992",
                "8722",
                "6518",
                "6507",
                "10840",
                "14522",
                "11514",
                "6499",
                "6507",
                "10175",
                "11383",
                "11844",
                "10176",
                "10174",
                "10176",
                "11871",
                "11511",
                "9063",
                "11027",
                "5502",
                "11214",
                "10996",
                "10996",
                "14993",
                "11875",
                "10176",
                "11865",
                "11875",
                "11867",
                "11871",
                "11878",
                "11875",
                "11536",
                "11866",
                "5500",
                "11381",
                "9903",
                "11023"
            ],
            marketObjects: {}
        },
        {
            "name": "Yarılar",
            "betCategory": 6,
            "markets": [
                "6500",
                "8719",
                "11553",
                "9028",
                "11549",
                "11537",
                "11011",
                "11550",
                "11543",
                "11035",
                "9027",
                "8724",
                "8726",
                "7648",
                "11542",
                "5520",
                "11556",
                "5520",
                "11035",
                "8725",
                "10377",
                "11011",
                "11547",
                "11542",
                "11011",
                "11548",
                "11555",
                "6502",
                "14052",
                "8725",
                "11563",
                "11541",
                "8989",
                "11537",
                "6505",
                "8725",
                "8987",
                "10831",
                "6498",
                "5518",
                "10435",
                "8715",
                "5520",
                "8725",
                "11536",
                "10379",
                "8718",
                "11564",
                "8728",
                "11545",
                "8712",
                "11562",
                "14052",
                "6500",
                "11554",
                "15152",
                "11023",
                "6499",
                "10380",
                "6500",
                "11027",
                "5519",
                "6500",
                "6500",
                "8962",
                "5520",
                "5520",
                "8963",
                "11561",
                "11543",
                "11560",
                "11035",
                "5520",
                "6500",
                "11387",
                "6503",
                "11382",
                "14052",
                "11546",
                "11541",
                "10328",
                "6500",
                "11388",
                "11387",
                "6498",
                "6597",
                "11387",
                "11382",
                "11388",
                "6504",
                "11388",
                "8962",
                "11382",
                "6500",
                "11387",
                "5520",
                "6499",
                "11382",
                "6498",
                "6498",
                "11388",
                "11388",
                "11388",
                "6500",
                "11212",
                "8962",
                "6499",
                "8962",
                "11387",
                "11388",
                "11387",
                "11387",
                "6499",
                "11388",
                "11387",
                "6498",
                "11211",
                "5520",
                "11387",
                "6499",
                "5520",
                "6499",
                "11388",
                "8962",
                "6499",
                "11388",
                "8962",
                "6500",
                "11387",
                "6593",
                "11387",
                "5520",
                "6500",
                "5520",
                "8962",
                "11387",
                "6594",
                "11387",
                "11387",
                "11388",
                "11388",
                "5520",
                "11382",
                "5520",
                "8962",
                "11382",
                "6500",
                "6500",
                "6500",
                "6499",
                "6499",
                "6498",
                "6498",
                "11387",
                "8962",
                "11387",
                "6500",
                "11388",
                "15155",
                "8986",
                "8983",
                "10378",
                "14052",
                "14052",
                "11551",
                "8727",
                "6598",
                "11543",
                "11559",
                "11544",
                "8713",
                "8711",
                "11552",
                "11540",
                "11540"
            ], marketObjects: {}
        },
        {
            "name": "Korner",
            "betCategory": 7,
            "markets": [
                "48",
                "49",
                "52",
                "53",
                "56",
                "67",
                "68",
                "210",
                "211",
                "215",
                "217",
                "218",
                "222"
            ],
            marketObjects: {}
        },
        {
            "name": "Özel",
            "betCategory": 8,
            "markets": [
                "10",
                "17",
                "86",
                "252",
                "27",
                "54",
                "801",
                "802",
                "803",
                "804",
                "800",
                "658",
                "12",
                "661",
                "3"
            ],
            marketObjects: {}
        }, {
            "name": "Handikap",
            "betCategory": 8,
            "markets": [
                "8724",
                "6500",
                "5503",
                "11035",
                "10046",
                "8962",
                "11214",
                "6500",
                "10046",
                "11035",
                "5504",
                "5504",
                "6500",
                "6500",
                "5503",
                "5503",
                "10046",
                "11035",
                "10046",
                "10046",
                "10046",
                "5503",
                "5503",
                "11214",
                "8724",
                "5503",
                "5503",
                "10046",
                "9021",
                "8962",
                "5503",
                "9023",
                "10046",
                "8724",
                "5503",
                "8724",
                "8963",
                "8963",
                "11035",
                "9019",
                "10046",
                "6500",
                "11035",
                "8963",
                "5503",
                "5503",
                "8956",
                "10257",
                "8956",
                "8956",
                "10257",
                "8724",
                "10046",
                "11035",
                "11035",
                "14170",
                "9649",
                "8956",
                "10257",
                "10046",
                "5504",
                "10911",
                "8956",
                "8956",
                "5504",
                "5503",
                "9017",
                "10350",
                "9649",
                "9649",
                "11214",
                "11035",
                "10822",
                "11049",
                "11049"
            ],
            marketObjects: {}
        }, {
            "name": "Korner",
            "betCategory": 8,
            "markets": [
                "8720",
                "6506",
                "6507",
                "6507",
                "8720",
                "8956",
                "9651",
                "10257",
                "9904",
                "10967",
                "8956",
                "8956",
                "10444",
                "9903",
                "10257",
                "8720",
                "11585",
                "11789",
                "10371",
                "8957",
                "10373",
                "6509",
                "11383",
                "6509",
                "8720",
                "8956",
                "9903",
                "10257",
                "6508",
                "6507",
                "9904",
                "10911",
                "6507",
                "8720",
                "6508",
                "8956",
                "8956",
                "6508",
                "11585",
                "6507",
                "6507",
                "6508",
                "6509",
                "6507",
                "8720",
                "6507",
                "6507",
                "11383",
                "9903",
                "11049",
                "11049"
            ],
            marketObjects: {}
        }
    ],
    "e-football": [
        {
            name: "Tümü",
            betCategory: 1,
            markets: [],
            marketObjects: {}
        },
        {
            name: "Maç",
            betCategory: 4,
            markets: [
                "1",
                "4",
                "100",
                "12",
                "7",
                "643",
                "644",
                "69",
                "72",
                "92",
                "129",
                "11",
                "42",
                "90",
                "23",
                "36",
                "321",
                "27"
            ],
            marketObjects: {}
        },
        {
            name: "Toplamlar",
            betCategory: 5,
            markets: [
                "87",
                "7",
                "101",
                "14",
                "89",
                "131",
                "4",
                "603",
                "203",
                "604",
                "207",
                "45",
                "6",
                "199",
                "84",
                "85",
                "43",
                "44",
                "91",
                "136",
                "34",
                "54"
            ],
            marketObjects: {}
        },
        {
            "name": "Yarılar",
            "betCategory": 6,
            "markets": [
                "88",
                "47",
                "60",
                "63",
                "6",
                "199",
                "84",
                "85",
                "77",
                "625"
            ], marketObjects: {}
        },
        {
            "name": "Korner",
            "betCategory": 7,
            "markets": [
                "48",
                "49",
                "52",
                "53",
                "56",
                "67",
                "68",
                "210",
                "211",
                "215",
                "217",
                "218",
                "222"
            ],
            marketObjects: {}
        },
        {
            "name": "Özel",
            "betCategory": 8,
            "markets": [
                "10",
                "17",
                "86",
                "252",
                "27",
                "54",
                "801",
                "802",
                "803",
                "804",
                "800",
                "658",
                "12",
                "661",
                "3"
            ],
            marketObjects: {}
        }
    ],
    "duello": [
        {
            name: "Tümü",
            betCategory: 1,
            markets: [],
            marketObjects: {}
        },
        {
            name: "Yeni",
            betCategory: 2,
            markets: [
                "728",
                "731",
                "732",
                "733",
                "734",
                "735",
                "736",
                "737",
                "738",
                "707",
                "739",
                "708",
                "709",
                "740",
                "759",
                "760",
                "761",
                "762",
                "763",
                "764",
                "765",
                "766",
                "717",
                "700",
                "727",
                "728",
                "720",
                "56",
                "722",
                "723",
                "724",
                "698",
                "699",
                "725",
            ],
            marketObjects: {}
        },
        {
            name: "Taraf",
            betCategory: 3,
            markets: [
                "1",
                "4",
                "100",
                "12",
                "7",
                "643",
                "644",
                "69",
                "72",
                "92",
                "129",
                "11",
                "42",
                "90",
                "23",
                "36",
                "321",
                "27"
            ],
            marketObjects: {}
        },
        {
            name: "Gol",
            betCategory: 4,
            markets: [
                "87",
                "7",
                "101",
                "14",
                "89",
                "131",
                "4",
                "603",
                "203",
                "604",
                "207",
                "45",
                "6",
                "199",
                "84",
                "85",
                "43",
                "44",
                "91",
                "136",
                "34",
                "54"
            ],
            marketObjects: {}
        },
        {
            "name": "Yarı",
            "betCategory": 5,
            "markets": [
                "88",
                "47",
                "60",
                "63",
                "6",
                "199",
                "84",
                "85",
                "77",
                "625"
            ], marketObjects: {}
        },
        {
            "name": "Korner",
            "betCategory": 6,
            "markets": [
                "48",
                "49",
                "52",
                "53",
                "56",
                "67",
                "68",
                "210",
                "211",
                "215",
                "217",
                "218",
                "222"
            ],
            marketObjects: {}
        },
        {
            "name": "Özel",
            "betCategory": 7,
            "markets": [
                "10",
                "17",
                "86",
                "252",
                "27",
                "54",
                "801",
                "802",
                "803",
                "804",
                "800",
                "658",
                "12",
                "661",
                "3"
            ],
            marketObjects: {}
        }
    ],
    "soccer": [
        {
            "name": "Tümü",
            "betCategory": 1,
            "markets": []
        },
        {
            name: "Yeni",
            betCategory: 2,
            markets: [
                "728",
                "731",
                "732",
                "733",
                "734",
                "735",
                "736",
                "737",
                "738",
                "707",
                "739",
                "708",
                "709",
                "740",
                "717",
                "700",
                "727",
                "728",
                "720",
                "56",
                "722",
                "723",
                "724",
                "698",
                "699",
                "725",
            ],
            marketObjects: {}
        },
        {
            "name": "Hızlı",
            "betCategory": 3,
            "markets": [
                '759',
                '760',
                '761',
                '762',
                '763',
                '764',
                '765',
                '766'
            ],
            marketObjects: {}
        },
        {
            "name": "Taraf",
            "betCategory": 4,
            "markets": [
                "1",
                "4",
                "100",
                "12",
                "7",
                "643",
                "644",
                "69",
                "72",
                "92",
                "129",
                "11",
                "42",
                "90",
                "23",
                "36",
                "321",
                "27"
            ]
        },
        {
            "name": "Gol",
            "betCategory": 5,
            "markets": [
                "87",
                "7",
                "101",
                "14",
                "89",
                "131",
                "4",
                "603",
                "203",
                "604",
                "207",
                "45",
                "6",
                "199",
                "84",
                "85",
                "43",
                "44",
                "91",
                "136",
                "34",
                "54"
            ]
        },
        {
            "name": "Yarı",
            "betCategory": 6,
            "markets": [
                "88",
                "47",
                "60",
                "63",
                "6",
                "199",
                "84",
                "85",
                "77",
                "625"
            ]
        },
        {
            "name": "Korner",
            "betCategory": 7,
            "markets": [
                "48",
                "49",
                "52",
                "53",
                "56",
                "67",
                "68",
                "210",
                "211",
                "215",
                "217",
                "218",
                "222"
            ]
        },
        {
            "name": "Özel",
            "betCategory": 8,
            "markets": [
                "10",
                "17",
                "86",
                "252",
                "27",
                "54",
                "801",
                "802",
                "803",
                "804",
                "800",
                "658",
                "12",
                "661",
                "3"
            ]
        }
    ],
    "basketbol": [
        {
            "name": "Tümü",
            "betCategory": 1,
            "markets": []
        },
        {
            name: "Yeni",
            betCategory: 2,
            markets: [
                "673",
                "750",
                "751",
                "752",
                "742",
                "747",
                "748",
                "749",
                "660",
                "755",
                "756",
                "757",
                "746",
                "747",
                "749",
                "758",
                "759",
                "760",
                "748",
                "750",
                "769",
                "768",
            ],
        },
        {
            "name": "Taraf",
            "betCategory": 3,
            "markets": [
                "2",
                "111",
                "660",
                "105",
                "113",
                "113",
                "622",
                "71",
                "673",
                "104",
                "186",
                "286"
            ]
        },
        {
            "name": "Sayı",
            "betCategory": 4,
            "markets": [
                "107",
                "114",
                "619",
                "620",
                "622",
                "140",
                "615",
                "616"
            ]
        },
        {
            "name": "Yarı",
            "betCategory": 5,
            "markets": [
                "621",
                "606",
                "106",
                "77",
                "115",
                "64",
                "116"
            ]
        }
    ],
    "basketball": [
        {
            "name": "Tümü",
            "betCategory": 1,
            "markets": []
        },
        {
            name: "Yeni",
            betCategory: 2,
            markets: [
                "673",
                "750",
                "751",
                "752",
                "742",
                "747",
                "748",
                "749",
                "660",
                "755",
                "756",
                "757",
                "746",
                "747",
                "749",
                "758",
                "759",
                "760",
                "748",
                "750",
                "769",
                "768",
            ],
        },
        {
            "name": "Taraf",
            "betCategory": 3,
            "markets": [
                "2",
                "111",
                "660",
                "105",
                "113",
                "622",
                "71",
                "673",
                "286"
            ]
        },
        {
            "name": "Sayı",
            "betCategory": 4,
            "markets": [
                "107",
                "114",
                "619",
                "620",
                "622",
                "140",
                "615",
                "616"
            ]
        },
        {
            "name": "Yarı",
            "betCategory": 5,
            "markets": [
                "621",
                "606",
                "106",
                "77",
                "115",
                "64",
                "116"
            ]
        }
    ],
    "basket": [
        {
            "name": "Tümü",
            "betCategory": 1,
            "markets": []
        },
        {
            name: "Yeni",
            betCategory: 2,
            markets: [
                "673",
                "750",
                "751",
                "752",
                "742",
                "747",
                "748",
                "749",
                "660",
                "755",
                "756",
                "757",
                "746",
                "747",
                "749",
                "758",
                "759",
                "760",
                "748",
                "750",
                "769",
                "768",
            ],
        },
        {
            "name": "Taraf",
            "betCategory": 3,
            "markets": [
                "2",
                "111",
                "660",
                "105",
                "113",
                "622",
                "71",
                "673",
                "286"
            ]
        },
        {
            "name": "Sayı",
            "betCategory": 4,
            "markets": [
                "107",
                "114",
                "619",
                "620",
                "622",
                "140",
                "615",
                "616"
            ]
        },
        {
            "name": "Yarı",
            "betCategory": 5,
            "markets": [
                "621",
                "606",
                "106",
                "77",
                "115",
                "64",
                "116"
            ]
        }
    ],
    "tenis": [
        {
            "name": "Tümü",
            "betCategory": 1,
            "markets": []
        },
        {
            name: "Yeni",
            betCategory: 2,
            markets: [
                "712",
                "717",
                "702",
                "707",
                "701",
                "703",
                "704",
                "705",
                "709",
                "710",
                "711",
                "713",
                "714",
                "715",
                "718",
                "743",
                "744",
                "745",
                "746",
                "719",
                "720",
                "767",
            ]
        },
        {
            "name": "Taraf",
            "betCategory": 2,
            "markets": [
                "9",
                "56",
                "649",
                "613",
                "166",
                "57",
                "169",
                "647",
                "648",
                "652",
                "607",
                "608",
                "609"
            ]
        },
        {
            "name": "Sayı",
            "betCategory": 3,
            "markets": [
                "168",
                "191",
                "167",
                "122",
                "170",
                "124",
                "650",
                "622",
                " -651",
                "623"
            ]
        },
        {
            "name": "Skor",
            "betCategory": 4,
            "markets": [
                "171",
                "274",
                "172",
                "276"
            ]
        }
    ],
    "tennis": [
        {
            "name": "Tümü",
            "betCategory": 1,
            "markets": []
        },
        {
            name: "Yeni",
            betCategory: 2,
            markets: [
                "712",
                "717",
                "702",
                "707",
                "701",
                "703",
                "704",
                "705",
                "709",
                "710",
                "711",
                "713",
                "714",
                "715",
                "718",
                "743",
                "744",
                "745",
                "746",
                "719",
                "720",
                "767",
            ]
        },
        {
            "name": "Taraf",
            "betCategory": 2,
            "markets": [
                "9",
                "56",
                "649",
                "613",
                "166",
                "57",
                "169",
                "647",
                "648",
                "652",
                "607",
                "608",
                "609"
            ]
        },
        {
            "name": "Sayı",
            "betCategory": 3,
            "markets": [
                "168",
                "191",
                "167",
                "122",
                "170",
                "124",
                "650",
                "622",
                "651",
                "623"
            ]
        },
        {
            "name": "Skor",
            "betCategory": 4,
            "markets": [
                "171",
                "274",
                "172",
                "276"
            ]
        }
    ],
    "voleybol": [
        {
            "name": "Tümü",
            "betCategory": 1,
            "markets": []
        },
        {
            name: "Yeni",
            betCategory: 2,
            markets: [
                "724",
                "711",
                "712",
                "714",
                "713",
                "723",
                "715",
                "716",
            ]
        },
        {
            "name": "Taraf",
            "betCategory": 2,
            "markets": [
                "10",
                "231",
                "114",
                "239"
            ]
        },
        {
            "name": "Sayı",
            "betCategory": 3,
            "markets": [
                "217",
                "18",
                "146",
                "157",
                "167",
                "171",
                "190"
            ]
        },
        {
            "name": "Skor",
            "betCategory": 4,
            "markets": [
                "220",
                "277"
            ]
        }
    ],
    "volleyball": [
        {
            "name": "Tümü",
            "betCategory": 1,
            "markets": []
        },
        {
            name: "Yeni",
            betCategory: 2,
            markets: [
                "724",
                "711",
                "712",
                "714",
                "713",
                "723",
                "715",
                "716",
            ]
        },
        {
            "name": "Taraf",
            "betCategory": 2,
            "markets": [
                "10",
                "231",
                "114",
                "239"
            ]
        },
        {
            "name": "Sayı",
            "betCategory": 3,
            "markets": [
                "217",
                "18"
            ]
        },
        {
            "name": "Skor",
            "betCategory": 4,
            "markets": [
                "220",
                "277"
            ]
        }
    ],
    "hentbol": [
        {
            "name": "Tümü",
            "betCategory": 1,
            "markets": []
        },
        {
            "name": "Taraf",
            "betCategory": 2,
            "markets": [
                "16",
                "185",
                "187",
                "3",
                "633"
            ]
        },
        {
            "name": "Gol",
            "betCategory": 3,
            "markets": [
                "184",
                "191",
                "20",
                "133"
            ]
        }
    ],
    "handball": [
        {
            "name": "Tümü",
            "betCategory": 1,
            "markets": []
        },
        {
            "name": "Taraf",
            "betCategory": 2,
            "markets": [
                "16",
                "185",
                "187",
                "3",
                "633"
            ]
        },
        {
            "name": "Gol",
            "betCategory": 3,
            "markets": [
                "184",
                "191",
                "20",
                "133"
            ]
        }
    ],
    "snooker": [
        {
            "name": "Tümü",
            "betCategory": 1,
            "markets": []
        },
        {
            "name": "Taraf",
            "betCategory": 2,
            "markets": [
                "15",
                "641",
                "600"
            ]
        },
        {
            "name": "Sayı",
            "betCategory": 3,
            "markets": [
                "642",
                "602"
            ]
        }
    ],
    "masa-tenisi": [
        {
            "name": "Tümü",
            "betCategory": 1,
            "markets": []
        },
        {
            "name": "Taraf",
            "betCategory": 2,
            "markets": [
                "15",
                "641",
                "600"
            ]
        },
        {
            "name": "Sayı",
            "betCategory": 3,
            "markets": [
                "642",
                "602"
            ]
        }
    ],
    "table-tennis": [
        {
            "name": "Tümü",
            "betCategory": 1,
            "markets": []
        }
    ],
    "buz-hokeyi": [
        {
            "name": "Tümü",
            "betCategory": 1,
            "markets": []
        },
        {
            "name": "Taraf",
            "betCategory": 2,
            "markets": [
                "21",
                "601",
                "161",
                "163",
                "126",
                "617",
                "127",
                "137",
                "1",
                "120",
                "128",
                "9",
                "37",
                "639"
            ]
        },
        {
            "name": "Gol",
            "betCategory": 3,
            "markets": [
                "164",
                "157",
                "135",
                "158",
                "619",
                "135",
                "21"
            ]
        }
    ],
    "ice-hockey": [
        {
            "name": "Tümü",
            "betCategory": 1,
            "markets": []
        },
        {
            "name": "Taraf",
            "betCategory": 2,
            "markets": [
                "21",
                "601",
                "161",
                "163",
                "126",
                "617",
                "127",
                "137",
                "1",
                "120",
                "128",
                "9",
                "37",
                "639"
            ]
        },
        {
            "name": "Gol",
            "betCategory": 3,
            "markets": [
                "164",
                "157",
                "135",
                "158"
            ]
        }
    ],
    "motor-sporlar": [
        {
            "name": "Tümü",
            "betCategory": 1,
            "markets": []
        }
    ],
    "moto-gp": [
        {
            "name": "Tümü",
            "betCategory": 1,
            "markets": []
        }
    ],
    "mma": [
        {
            "name": "Tümü",
            "betCategory": 1,
            "markets": []
        }
    ],
    "league-of-legends": [
        {
            "name": "Tümü",
            "betCategory": 1,
            "markets": []
        }
    ],
    "dota-2": [
        {
            "name": "Tümü",
            "betCategory": 1,
            "markets": []
        }
    ],
    "beach-volleyball": [
        {
            "name": "Tümü",
            "betCategory": 1,
            "markets": []
        }
    ],
    "boxing": [
        {
            "name": "Tümü",
            "betCategory": 1,
            "markets": []
        }
    ],
    "futsal": [
        {
            "name": "Tümü",
            "betCategory": 1,
            "markets": []
        }
    ],
    "golf": [
        {
            "name": "Tümü",
            "betCategory": 1,
            "markets": []
        }
    ],
    "curling": [
        {
            "name": "Tümü",
            "betCategory": 1,
            "markets": []
        }
    ],
    "rugby-union": [
        {
            "name": "Tümü",
            "betCategory": 1,
            "markets": []
        }
    ],
    "floorball": [
        {
            "name": "Tümü",
            "betCategory": 1,
            "markets": []
        }
    ],
    "dotagreco-roman-wrestling": [
        {
            "name": "Tümü",
            "betCategory": 1,
            "markets": []
        }
    ],
    "badminton": [
        {
            "name": "Tümü",
            "betCategory": 1,
            "markets": []
        }
    ],
    "darts": [
        {
            "name": "Tümü",
            "betCategory": 1,
            "markets": []
        }
    ],
    "baseball": [
        {
            "name": "Tümü",
            "betCategory": 1,
            "markets": []
        }
    ],
    "cricket": [
        {
            "name": "Tümü",
            "betCategory": 1,
            "markets": []
        }
    ],
    "counter-strike-go": [
        {
            "name": "Tümü",
            "betCategory": 1,
            "markets": []
        }
    ],
    "counter-strike-2": [
        {
            "name": "Tümü",
            "betCategory": 1,
            "markets": []
        }
    ],
    "starcraft-2": [
        {
            "name": "Tümü",
            "betCategory": 1,
            "markets": []
        }
    ],
    "overwatch": [
        {
            "name": "Tümü",
            "betCategory": 1,
            "markets": []
        }
    ],
    "heartstone": [
        {
            "name": "Tümü",
            "betCategory": 1,
            "markets": []
        }
    ],
    "esoccer": [
        {
            "name": "Tümü",
            "betCategory": 1,
            "markets": []
        }
    ],
    "ebasketball": [
        {
            "name": "Tümü",
            "betCategory": 1,
            "markets": []
        }
    ],
    "politics": [
        {
            "name": "Tümü",
            "betCategory": 1,
            "markets": []
        }
    ],
    "american-football": [
        {
            "name": "Tümü",
            "betCategory": 1,
            "markets": []
        }
    ],
    "valorant": [
        {
            "name": "Tümü",
            "betCategory": 1,
            "markets": []
        }
    ],
    "water-polo": [
        {
            "name": "Tümü",
            "betCategory": 1,
            "markets": []
        }
    ],
    "rainbow-six": [
        {
            "name": "Tümü",
            "betCategory": 1,
            "markets": []
        }
    ],
    "crossfire": [
        {
            "name": "Tümü",
            "betCategory": 1,
            "markets": []
        }
    ],
    "pickleball": [
        {
            "name": "Tümü",
            "betCategory": 1,
            "markets": []
        }
    ],
    "netball": [
        {
            "name": "Tümü",
            "betCategory": 1,
            "markets": []
        }
    ],
    "skateboarding": [
        {
            "name": "Tümü",
            "betCategory": 1,
            "markets": []
        }
    ],
    "eurovision": [
        {
            "name": "Tümü",
            "betCategory": 1,
            "markets": []
        }
    ],
    "special-bets": [
        {
            "name": "Tümü",
            "betCategory": 1,
            "markets": []
        }
    ],
    "nascar": [
        {
            "name": "Tümü",
            "betCategory": 1,
            "markets": []
        }
    ],
    "gaelic-football": [
        {
            "name": "Tümü",
            "betCategory": 1,
            "markets": []
        }
    ],
    "surfing": [
        {
            "name": "Tümü",
            "betCategory": 1,
            "markets": []
        }
    ],
    "mobile-legends": [
        {
            "name": "Tümü",
            "betCategory": 1,
            "markets": []
        }
    ],
    "speedway": [
        {
            "name": "Tümü",
            "betCategory": 1,
            "markets": []
        }
    ],
    "king-of-glory": [
        {
            "name": "Tümü",
            "betCategory": 1,
            "markets": []
        }
    ],
    "3x3-basketball": [
        {
            "name": "Tümü",
            "betCategory": 1,
            "markets": []
        }
    ],
    "rugby-league": [
        {
            "name": "Tümü",
            "betCategory": 1,
            "markets": []
        }
    ],
    "ski-jumping": [
        {
            "name": "Tümü",
            "betCategory": 1,
            "markets": []
        }
    ],
};
export var marketNamesMappingData = {
    '1': {
        name: 'Maç Sonucu',
        tooltip: '90 dakika sonunda maçın nasıl biteceğinin tahmin edildiği oyun tipidir. Bu oyunda ikili tahmin yapılamaz. Üç tahmin vardır; Ev sahibi takım (1), Beraberlik (0), Deplasman takımı (2)'
    },
    '2': {
        name: 'Maç Skoru',
        tooltip: 'Maç skorunun tahmin edildiği oyun tipidir.'
    },
    '7': {
        name: 'Maç Sonucu ve Alt/Üst',
        tooltip: 'Kombine tahminin yapıldığı oyun tipidir. Aynı anda hem maç sonucunun, hem de maç için belirlenen toplam gol sayısından daha az veya daha fazla gol olacağının tahmini yapılır.'
    },
    '10': {
        name: 'Uzatma Olur mu',
        tooltip: 'Maçın 90 dakikasının ardından uzatmaya gidilip gidilmeyeceğinin tahmin edildiği oyun tipidir. İki tahmin vardır; Evet, Hayır'
    },
    '11': {
        name: 'Hangi Takım Kaç Farkla Kazanır',
        tooltip: 'Bir takımın kaç farklı skorla galip geleceğinin tahmin edildiği oyun tipidir. Yedi tahmin vardır; Ev sahibi takım 3+, Ev sahibi takım 2, Ev sahibi takım 1, Deplasman takımı 3+, Deplasman takımı 2, Deplasman takımı 1, Beraberlik'
    },
    '36': {
        name: 'İkinci Yarı Sonucu',
        tooltip: 'İkinci yarının nasıl biteceğinin tahmin edildiği oyun tipidir. Bu oyunda ikili tahmin yapılamaz. Üç tahmin vardır; Ev sahibi takım (1), Beraberlik (0), Deplasman takımı (2)'
    },
    '274': {
        name: 'Maç Skoru',
        tooltip: '2 kazanılan setin galibiyete yeteceği bir tenis maçında, maç skorunun tahmin edildiği oyun tipidir.'
    },
    '276': {
        name: 'Maç Skoru',
        tooltip: '3 kazanılan setin galibiyete yeteceği bir tenis maçında, maç skorunun tahmin edildiği oyun tipidir.'
    },
    '166': {
        name: '1.Set Kazanan',
        tooltip: 'Setin nasıl biteceğinin tahmin edildiği oyun tipidir. İki tahmin vardır; Ev sahibi 1. Oyuncu (1), Deplasman 2. Oyuncu (2)'
    },
    '115': {
        name: 'İlk Yarı Handikap',
        tooltip: 'Handikap seçeneği bulunan takım, belirlenen sayı kadar maça önde başlamış sayılır (sayı avansı) ve bu sayı hesaba katılarak ilk yarıyı (2. çeyrek) hangi takımın galip bitireceğinin tahmin edildiği oyun tipidir.'
    },
    '169': {
        name: '2.Set Kazanan',
        tooltip: 'Setin nasıl biteceğinin tahmin edildiği oyun tipidir. İki tahmin vardır; Ev sahibi 1. Oyuncu (1), Deplasman 2. Oyuncu (2)'
    },
    '167': {
        name: 'Toplam Set Sayısı',
        tooltip: '2 kazanılan setin galibiyete yeteceği bir tenis maçında, her iki oyuncunun maç boyunca kazanacakları toplam set sayısına göre tahmin yapılır. İki tahmin vardır; 2 Set, 3 Set.'
    },
    '140': {
        name: 'Toplam Sayı Alt/Üst (Uzatmalar Dahil)',
        tooltip: 'Uzatmalar dahil olmak üzere, maçta atılacak toplam sayının programda belirtilen sayı bareminden daha az veya daha fazla olacağının tahmin edildiği oyun tipidir.'
    },
    '642': {
        name: 'Toplam Frame Alt/Üst',
        tooltip: 'Her iki takımın maç boyunca kazanacakları toplam frame\'in programda belirtilen sayının altında veya üstünde olduğunun tahmin edilmesidir.'
    },
    '172': {
        name: 'Maç Skoru',
        tooltip: '3 kazanılan setin galibiyete yeteceği bir tenis maçında, maç skorunun tahmin edildiği oyun tipidir.'
    },
    '57': {
        name: 'Hangi Oyuncu Seti Kazanır',
        tooltip: 'Setin nasıl biteceğinin tahmin edildiği oyun tipidir. İki tahmin vardır; Ev sahibi 1. Oyuncu (1), Deplasman 2. Oyuncu (2)'
    },
    '122': {
        name: 'Toplam Set Sayısı',
        tooltip: '2 kazanılan setin galibiyete yeteceği bir tenis maçında, her iki oyuncunun maç boyunca kazanacakları toplam set sayısına göre tahmin yapılır. İki tahmin vardır; 2 Set, 3 Set.'
    },
    '321': {
        name: 'İkinci Yarı Sonucu',
        tooltip: 'İkinci yarının nasıl biteceğinin tahmin edildiği oyun tipidir. Bu oyunda ikili tahmin yapılamaz. Üç tahmin vardır; Ev sahibi takım (1), Beraberlik (0), Deplasman takımı (2)'
    },
    '647': {
        name: '1. Oyuncu Set Kazanır',
        tooltip: 'İki tahmin vardır; Evet, Hayır'
    },
    '623': {
        name: '2. Oyuncu Toplam Oyun Alt/Üst',
        tooltip: '2. Oyuncunun (deplasman) kazanacağı toplam oyun sayısına göre tahmin yapılır. Handikaplar buçukludur ve bu nedenle beraberlik seçeneği bulunmamaktadır.'
    },
    '256': {
        name: 'Maç Sonucu ve Alt/Üst',
        tooltip: 'Kombine tahminin yapıldığı oyun tipidir. Aynı anda hem maç sonucunun, hem de maç için belirlenen toplam gol sayısından daha az veya daha fazla gol olacağının tahmini yapılır.'
    },
    '648': {
        name: '2. Oyuncu Set Kazanır',
        tooltip: 'İki tahmin vardır; Evet, Hayır'
    },
    '649': {
        name: 'Handikaplı Maç Sonucu (Oyun Handikapı)',
        tooltip: 'Belirtilen oyuncuya verilen oyun avansıdır. Oyun avansı verilen takım maça verilen oyun sayısı kadar önde başlar. İki ihtimali bulunan bu oyunda (01) Ev Sahibi, (02) Deplasman şeklinde kodlanmaktadır.'
    },
    '650': {
        name: '1. Oyuncu Toplam Oyun Alt/Üst',
        tooltip: '1. Oyuncunun (ev sahibi) kazanacağı toplam oyun sayısına göre tahmin yapılır. Handikaplar buçukludur ve bu nedenle beraberlik seçeneği bulunmamaktadır.'
    },
    '651': {
        name: '2. Oyuncu Toplam Oyun Alt/Üst',
        tooltip: '2. Oyuncunun (deplasman) kazanacağı toplam oyun sayısına göre tahmin yapılır. Handikaplar buçukludur ve bu nedenle beraberlik seçeneği bulunmamaktadır.'
    },
    '652': {
        name: 'Tie Break Olur mu?',
        tooltip: 'İki tahmin vardır; Evet, Hayır'
    },
    '654': {
        name: 'Handikaplı Maç Sonucu',
        tooltip: 'Handikap seçeneği bulunan oyuncu, belirlenen set sayısı kadar maça önde başlamış sayılır (set avansı) ve bu sayı hesaba katılarak maçı hangi takımın galip bitireceğinin tahmin edildiği oyun tipidir.'
    },
    '42': {
        name: 'Maç Sonucuna Nasıl Ulaşılır',
        tooltip: 'Altı farklı tahmin vardır; Ev sahibi takım-normal süre, Ev sahibi takım-uzatmalar, Ev sahibi takım-penaltılar, Deplasman takımı-normal süre, Deplasman takımı-uzatmalar, Deplasman takımı-penaltılar'
    },
    '69': {
        name: 'Ev Sahibi Takım Her İki Yarıyı da Kazanır mı',
        tooltip: 'Ev sahibi takımın her iki yarıda da rakibinden daha fazla gol atması gerekir. İki tahmin vardır; Evet, Hayır'
    },
    '72': {
        name: 'Deplasman Takımı Her İki Yarıyı da Kazanır mı',
        tooltip: 'Deplasman takımının her iki yarıda da rakibinden daha fazla gol atması gerekir. İki tahmin vardır; Evet, Hayır'
    },
    '77': {
        name: 'İlk Yarı Çifte Şans',
        tooltip: 'İlk Yarı sonucuna ilişkin bu oyunda, bir tahmin iki farklı sonucu kapsar. Üç tahmin vardır; 1-0 (Ev sahibi takım galibiyeti ve Beraberlik), 0-2 (Beraberlik ve Deplasman takım galibiyeti) ve 1-2 (Ev sahibi ve Deplasman takım galibiyeti)'
    },
    '88': {
        name: 'İlk Yarı Sonucu',
        tooltip: 'İlk yarının nasıl biteceğinin tahmin edildiği oyun tipidir. Üç tahmin vardır; Ev sahibi takım (1), Beraberlik (0), Deplasman takımı (2)'
    },
    '90': {
        name: 'İlk Yarı / Maç Sonucu',
        tooltip: 'Maçın ilk yarısının sonucu ile 90 dakika sonucunun kombine tahmin edildiği oyun tipidir. Dokuz tahmin vardır; 1/1, 1/0, 1/2, 0/1, 0/2, 0/0, 2/1, 2/0, 2/2'
    },
    '117': {
        name: 'Alt/Üst',
        tooltip: 'Her iki takımın maç boyunca atacakları toplam sayının programda belirtilen sayının altında veya üstünde olduğunun tahmin edilmesidir.'
    },
    '124': {
        name: 'Toplam Set Sayısı',
        tooltip: '3 kazanılan setin galibiyete yeteceği bir tenis maçında, her iki oyuncunun maç boyunca kazanacakları toplam set sayısına göre tahmin yapılır. Üç tahmin vardır; 3 Set, 4 Set, 5 Set.'
    },
    '168': {
        name: 'Toplam Oyun Alt/Üst',
        tooltip: 'Her iki oyuncunun maç boyunca kazanacakları toplam oyunun programda belirtilen sayının altında veya üstünde olduğunun tahmin edilmesidir.'
    },
    '170': {
        name: 'Toplam Set Sayısı',
        tooltip: '3 kazanılan setin galibiyete yeteceği bir tenis maçında, her iki oyuncunun maç boyunca kazanacakları toplam set sayısına göre tahmin yapılır. Üç tahmin vardır; 3 Set, 4 Set, 5 Set.'
    },
    '171': {
        name: 'Maç Skoru',
        tooltip: '2 kazanılan setin galibiyete yeteceği bir tenis maçında, maç skorunun tahmin edildiği oyun tipidir.'
    },
    '92': {
        name: 'Çifte Şans',
        tooltip: 'Maç sonucuna ilişkin bu oyunda, bir tahmin iki farklı sonucu kapsar. Üç tahmin vardır; 1-0 (Ev sahibi takım galibiyeti ve Beraberlik), 0-2 (Beraberlik ve Deplasman takım galibiyeti) ve 1-2 (Ev sahibi ve Deplasman takım galibiyeti)'
    },
    '100': {
        name: 'Handikaplı Maç Sonucu',
        tooltip: 'Handikap seçeneği bulunan takım, belirlenen gol kadar maça önde başlamış sayılır (gol avansı).'
    },
    '643': {
        name: 'Ev Sahibi Takım Gol Yemeden Kazanır mı?',
        tooltip: 'İki tahmin vardır; Evet, Hayır'
    },
    '644': {
        name: 'Deplasman Takımı Gol Yemeden Kazanır mı?',
        tooltip: 'İki tahmin vardır; Evet, Hayır'
    },
    '613': {
        name: 'Handikaplı Maç Sonucu (Oyun Handikapı)',
        tooltip: 'Belirtilen oyuncuya verilen oyun avansıdır. Oyun avansı verilen takım maça verilen oyun sayısı kadar önde başlar. İki ihtimali bulunan bu oyunda (01) Ev Sahibi, (02) Deplasman şeklinde kodlanmaktadır.'
    },
    '4': {
        name: 'Maç Sonucu',
        tooltip: '90 dakika sonunda maçın nasıl biteceğinin tahmin edildiği oyun tipidir. Bu oyunda ikili tahmin yapılamaz. Üç tahmin vardır; Ev sahibi takım (1), Beraberlik (0), Deplasman takımı (2)'
    },
    '12': {
        name: 'Handikaplı Maç Sonucu',
        tooltip: 'Handikap seçeneği bulunan takım, belirlenen gol kadar maça önde başlamış sayılır (gol avansı).'
    },
    '23': {
        name: 'Maçın Geri Kalanını Kim Kazanır ',
        tooltip: 'Bahsin yapılacağı dakikada skor 0-0 sayılır ve maçın geri kalanının sonucu tahmin edilir. Üç tahmin vardır; Ev sahibi takım, Beraberlik, Deplasman takımı'
    },
    '27': {
        name: 'Uzatmaları Kim Kazanır',
        tooltip: '90 dakikanın ardından geçilen uzatma bölümünü kazanacak takımın tahmin edildiği oyun tipidir. Üç tahmin vardır; Ev sahibi takım, Beraberlik, Deplasman takımı'
    },
    '47': {
        name: 'İlk Yarı Sonucu',
        tooltip: 'İlk yarının nasıl biteceğinin tahmin edildiği oyun tipidir. Üç tahmin vardır; Ev sahibi takım (1), Beraberlik (0), Deplasman takımı (2)'
    },
    '129': {
        name: 'Çifte Şans',
        tooltip: 'Maç sonucuna ilişkin bu oyunda, bir tahmin iki farklı sonucu kapsar. Üç tahmin vardır; 1-0 (Ev sahibi takım galibiyeti ve Beraberlik), 0-2 (Beraberlik ve Deplasman takım galibiyeti) ve 1-2 (Ev sahibi ve ve Deplasman takım galibiyeti)'
    },
    '625': {
        name: 'İlk Yarı Çifte Şans',
        tooltip: 'İlk Yarı sonucuna ilişkin bu oyunda, bir tahmin iki farklı sonucu kapsar. Üç tahmin vardır; 1-0 (Ev sahibi takım galibiyeti ve Beraberlik), 0-2 (Beraberlik ve Deplasman takım galibiyeti) ve 1-2 (Ev sahibi ve Deplasman takım galibiyeti)'
    },
    '6': {
        name: 'Hangi Yarıda Daha Fazla Gol olur',
        tooltip: 'Maçta hangi yarıda daha çok gol atılacağının tahmin edildiği oyun tipidir. Üç tahmin vardır; 1. yarı, 2. yarı, Berabere'
    },
    '43': {
        name: 'Ev Sahibi Gol Yemeden Bitirir',
        tooltip: 'İki tahmin vardır; Evet, Hayır'
    },
    '44': {
        name: 'Deplasman Gol Yemeden Bitirir',
        tooltip: 'İki tahmin vardır; Evet, Hayır'
    },
    '45': {
        name: 'Hangi Takım Gol Atar ',
        tooltip: 'Maçta hangi takımın gol atacağının tahmin edildiği oyun tipidir. Dört tahmin vardır; Sadece 1, Sadece 2, İkisi de, Gol olmaz'
    },
    '5520': {
        name: 'İlk Yarı Toplam Gol',
        tooltip: 'İlk yarıda atılacak gol sayısının tahmin edildiği oyun tipidir. '
    },
    '60': {
        name: 'İlk Yarı Alt/Üst',
        tooltip: 'İlk yarıda atılacak toplam gol sayısıyla ilgili oyun tipidir.'
    },
    '84': {
        name: 'Ev Sahibi Takım Hangi Yarıda Daha Çok Gol Atar',
        tooltip: 'Üç tahmin vardır; İlk yarı, İkinci yarı, Eşit'
    },
    '85': {
        name: 'Deplasman Takımı Hangi Yarıda Daha Çok Gol Atar',
        tooltip: 'Üç tahmin vardır; İlk yarı, İkinci yarı, Eşit'
    },
    '87': {
        name: 'İlk Golü Hangi Takım Atar',
        tooltip: 'Maçta ilk golü hangi takımın atacağının tahmin edildiği oyun tipidir. Gol olmaz tahmini de yapılabilir.'
    },
    '5508': {
        name: 'Karşılıklı Gol',
        tooltip: 'Maçta iki takımın da gol atacağı düşünülüyorsa Var tahmini, en az bir takımın gol atamayacağı düşünülüyorsa Yok tahmini seçilir.'
    },
    '91': {
        name: 'Tek / Çift',
        tooltip: 'Maçta atılacak toplam gol sayısının Tek veya Çift olacağının tahmin edildiği oyun tipidir. Örneğin; maç sonucu 0-0 (0 gol) veya 4-2 (6 gol) ise Çift, 2-1 (3 gol) veya 3-2 (5 gol) ise Tek tahmini kazanan bahistir.'
    },
    '5500': {
        name: 'Toplam Gol Alt/Üst',
        tooltip: 'Maçta atılacak toplam gol sayısıyla ilgili oyun tipidir.'
    },
    '603': {
        name: 'Ev Sahibi Alt/Üst',
        tooltip: 'Ev sahibi takımın atacağı toplam gol sayısına göre tahmin yapılır.'
    },
    '604': {
        name: 'Deplasman Alt/Üst',
        tooltip: 'Deplasman takımının atacağı toplam gol sayısına göre tahmin yapılır.'
    },
    '14': {
        name: 'Toplam Gol Alt/Üst',
        tooltip: 'Maçta atılacak toplam gol sayısıyla ilgili oyun tipidir.'
    },
    '34': {
        name: 'Sıradaki Gol',
        tooltip: 'Bahsin yapıldığı andan sonra ilk golü hangi takımın atacağının tahmin edildiği oyun tipidir. Üç tahmin vardır; Ev sahibi takım, Deplasman takımı, Gol Olmaz'
    },
    '54': {
        name: 'Uzatmalar Alt/Üst',
        tooltip: 'Uzatmalarda atılacak toplam gol sayısına göre yapılan tahmindir.'
    },
    '63': {
        name: 'İlk Yarı Alt/Üst',
        tooltip: 'İlk yarıda atılacak toplam gol sayısıyla ilgili oyun tipidir.'
    },
    '131': {
        name: 'Karşılıklı Gol',
        tooltip: 'Maçta iki takımın da gol atacağı düşünülüyorsa Var tahmini, en az bir takımın gol atamayacağı düşünülüyorsa Yok tahmini seçilir.'
    },
    '136': {
        name: 'Tek / Çift',
        tooltip: 'Maçta atılacak toplam gol sayısının Tek veya Çift olacağının tahmin edildiği oyun tipidir. Örneğin; maç sonucu 0-0 (0 gol) veya 4-2 (6 gol) ise Çift, 2-1 (3 gol) veya 3-2 (5 gol) ise Tek tahmini kazanan bahistir.'
    },
    '199': {
        name: 'Hangi Yarıda Daha Fazla Gol olur',
        tooltip: 'Maçta hangi yarıda daha çok gol atılacağının tahmin edildiği oyun tipidir. Üç tahmin vardır; 1. yarı, 2. yarı, Berabere'
    },
    '203': {
        name: 'Ev Sahibi Alt/Üst',
        tooltip: 'Ev sahibi takımın atacağı toplam gol sayısına göre tahmin yapılır.'
    },
    '207': {
        name: 'Deplasman Alt/Üst',
        tooltip: 'Deplasman takımının atacağı toplam gol sayısına göre tahmin yapılır.'
    },
    '262': {
        name: 'İlk Yarı Toplam Gol',
        tooltip: 'İlk yarıda atılacak gol sayısının tahmin edildiği oyun tipidir.'
    },
    '48': {
        name: 'Toplam Korner Alt/Üst',
        tooltip: 'Maçta atılacak toplam korner sayısına göre tahmin yapılır.'
    },
    '49': {
        name: 'İlk Yarı Toplam Korner Alt/Üst',
        tooltip: 'İlk yarıda atılacak toplam korner sayısına göre tahmin yapılır.'
    },
    '52': {
        name: 'Kim Daha Çok Korner Kullanır',
        tooltip: 'Maçta hangi takımın daha çok korner atacağının tahmin edildiği oyun tipidir. Üç tahmin vardır; Ev sahibi takım, Beraberlik, Deplasman takımı'
    },
    '53': {
        name: 'İlk Yarı Kim Daha Çok Korner Kullanır?',
        tooltip: 'İlk yarıda hangi takımın daha çok korner atacağının tahmin edildiği oyun tipidir. Üç tahmin vardır; Ev sahibi takım, Beraberlik, Deplasman takımı'
    },
    '56': {
        name: 'İlk Korneri Hangi Takım Kullanır',
        tooltip: 'İlk korneri hangi takımın atacağının tahmin edildiği oyun tipidir. Üç tahmin vardır; Ev sahibi takım, Deplasman takımı, Korner olmaz'
    },
    '67': {
        name: 'Toplam Korner',
        tooltip: 'Maçta toplam kaç kornerin atılacağının tahmin edildiği oyun tipidir. Üç tahmin vardır; 0-8, 9-11, 12+'
    },
    '68': {
        name: 'İlk Yarı Toplam Korner',
        tooltip: 'İlk yarıda toplam kaç kornerin atılacağının tahmin edildiği oyun tipidir. Üç tahmin vardır; 0-4, 5-6, 7+'
    },
    '210': {
        name: 'Kim Daha Çok Korner Kullanır',
        tooltip: 'Maçta hangi takımın daha çok korner atacağının tahmin edildiği oyun tipidir. Üç tahmin vardır; Ev sahibi takım, Beraberlik, Deplasman takımı'
    },
    '211': {
        name: 'Toplam Korner',
        tooltip: 'Maçta atılacak toplam korner sayısına göre tahmin yapılır.'
    },
    '609': {
        name: 'Tie Break Olur mu?',
        tooltip: 'İki tahmin vardır; Evet, Hayır'
    },
    '215': {
        name: 'Toplam Korner',
        tooltip: 'Maçta toplam kaç kornerin atılacağının tahmin edildiği oyun tipidir. Üç tahmin vardır; 0-8, 9-11, 12+'
    },
    '217': {
        name: 'İlk Yarıda Kim Daha Çok Korner Kullanır',
        tooltip: 'İlk yarıda hangi takımın daha çok korner atacağının tahmin edildiği oyun tipidir. Üç tahmin vardır; Ev sahibi takım, Beraberlik, Deplasman takımı'
    },
    '218': {
        name: 'İlk Yarı Toplam Korner',
        tooltip: 'İlk yarıda atılacak toplam korner sayısına göre tahmin yapılır.'
    },
    '222': {
        name: 'İlk Yarı Toplam Korner',
        tooltip: 'İlk yarıda toplam kaç kornerin atılacağının tahmin edildiği oyun tipidir. Üç tahmin vardır; 0-4, 5-6, 7+'
    },
    '3': {
        name: 'İlk Golü Atan Oyuncu',
        tooltip: 'Maçta ilk golü hangi oyuncunun atacağının tahmin edildiği oyun tipidir.'
    },
    '17': {
        name: 'Kırmızı Kart Olur mu',
        tooltip: 'İki tahmin vardır; Evet, Hayır'
    },
    '658': {
        name: 'Toplam kart sayısı Alt/Üst',
        tooltip: 'Maçta görülecek toplam kart sayısına göre tahmin yapılır.'
    },
    '661': {
        name: 'Son Golü Atan Oyuncu',
        tooltip: 'Maçta son golü hangi oyuncunun atacağının tahmin edildiği oyun tipidir.'
    },
    '800': {
        name: 'Hakem VAR Ekranını İzlemeye Kaç Kez Gider?',
        tooltip: 'Hakemin VAR ekranını izlemek için saha kenarına kaç defa gideceğinin tahmin edildiği oyun tipidir. Hakemin saha içerisinde iken VAR odası ile görüşmeleri dahil değildir.'
    },
    '801': {
        name: 'Toplam Ofsayt Sayısı',
        tooltip: 'Maçta olacak toplam ofsayt sayısına göre tahmin yapılır'
    },
    '802': {
        name: 'Penaltı Olur mu',
        tooltip: 'Maç içerisinde penaltı olup olmayacağının tahmin edildiği oyun tipidir.'
    },
    '803': {
        name: 'Kendi Kalesine Gol Olur mu',
        tooltip: 'Maç içerisinde herhangi bir oyuncunun kendi kalesine gol atıp atmayacağının tahmin edildiği oyun tipidir.'
    },
    '804': {
        name: 'Maç Sonu Tabelada Gösterilen Süre',
        tooltip: 'Maçın 90. dakikasında 4. hakemin tabelada kaç dakika uzatma göstereceğinin tahmin edildiği oyun tipidir.'
    },
    '86': {
        name: 'Maç Skoru',
        tooltip: 'Maç skorunun tahmin edildiği oyun tipidir.'
    },
    '252': {
        name: 'Maç Skoru',
        tooltip: 'Maç skorunun tahmin edildiği oyun tipidir.'
    },
    '107': {
        name: 'Hangi Çeyrekte Daha Çok Sayı Olur',
        tooltip: '4 çeyrek arasında hangisinde daha fazla sayı atılacağının tahmin edildiği oyun tipidir.'
    },
    '114': {
        name: 'Toplam Sayı Alt/Üst (Uzatmalar Dahil)',
        tooltip: 'Uzatmalar dahil olmak üzere, maçta atılacak toplam sayının programda belirtilen sayı bareminden daha az veya daha fazla olacağının tahmin edildiği oyun tipidir.'
    },
    '116': {
        name: 'İlk Yarı Toplam Sayı Alt/Üst',
        tooltip: 'Her iki takımın ilk yarı boyunca atacakları toplam sayının programda belirtilen sayının altında veya üstünde olduğunun tahmin edilmesidir.'
    },
    '619': {
        name: 'Ev Sahibi Alt/Üst (Uzatmalar Dahil)',
        tooltip: 'Ev sahibi takımın maç süresince atacağı toplam sayıya göre (uzatmalar dahil) tahmin yapılır.'
    },
    '620': {
        name: 'Deplasman Alt/Üst (Uzatmalar Dahil)',
        tooltip: 'Deplasman takımının maç süresince atacağı toplam sayıya göre (uzatmalar dahil) tahmin yapılır.'
    },
    '622': {
        name: 'Maç Sonucu ve Alt/Üst (Uzatmalar Dahil)',
        tooltip: 'Kombine tahminin yapıldığı oyun tipidir. Aynı anda hem maç sonucunun hem de programda belirtilecek sayıdan daha az veya daha fazla sayı atılacağının (uzatmalar dahil) tahmini yapılır.'
    },
    '64': {
        name: 'İlk Yarı Toplam Sayı Alt/Üst',
        tooltip: 'Her iki takımın ilk yarı boyunca atacakları toplam sayının programda belirtilen sayının altında veya üstünde olduğunun tahmin edilmesidir.'
    },
    '615': {
        name: 'Ev Sahibi Alt/Üst (Uzatmalar Dahil)',
        tooltip: 'Ev sahibi takımın maç süresince atacağı toplam sayıya göre (uzatmalar dahil) tahmin yapılır.'
    },
    '616': {
        name: 'Deplasman Alt/Üst (Uzatmalar Dahil)',
        tooltip: 'Deplasman takımının maç süresince atacağı toplam sayıya göre (uzatmalar dahil) tahmin yapılır.'
    },
    '104': {
        name: 'Uzatma Evet / Hayır ',
        tooltip: 'Maçın berabere bitip uzatmaya gidilip gidilmeyeceğinin tahmin edildiği oyun tipidir. İki tahmin vardır; Evet, Hayır'
    },
    '105': {
        name: 'Hangi Takım Kaç Farkla Kazanır (Uzatmalar Dahil)',
        tooltip: 'Bir takımın kaç farklı skorla galip geleceğinin (uzatmalar dahil) tahmin edildiği oyun tipidir. Yedi tahmin vardır; Ev sahibi takım 11+, Ev sahibi takım 6-10, Ev sahibi takım 1-5, Deplasman takımı 11+, Deplasman takımı 6-10, Deplasman takımı 1-5'
    },
    '106': {
        name: 'İlk Yarı Sonucu',
        tooltip: 'İlk yarının nasıl biteceğinin tahmin edildiği oyun tipidir. İki tahmin vardır; Ev sahibi takım (1), Deplasman takımı (2)'
    },
    '111': {
        name: 'İlk Yarı / Maç Sonucu',
        tooltip: 'Maçın ilk yarısının sonucu ile maç sonucunun kombine tahmin edildiği oyun tipidir. Dokuz tahmin vardır; 1/1, 1/0, 1/2, 0/1, 0/2, 0/0, 2/1, 2/0, 2/2'
    },
    '113': {
        name: 'Handikaplı Maç Sonucu (Uzatmalar Dahil)',
        tooltip: 'Handikap seçeneği bulunan takım, belirlenen sayı kadar maça önde başlamış sayılır (sayı avansı) ve bu sayı hesaba katılarak maç sonucunun (uzatmalar dahil) tahmin edildiği oyun tipidir.'
    },
    '621': {
        name: 'İlk Yarı Sonucu',
        tooltip: 'İlk yarının nasıl biteceğinin tahmin edildiği oyun tipidir. Üç tahmin vardır; Ev sahibi takım (1), Beraberlik (0), Deplasman takımı (2)'
    },
    '660': {
        name: '1. Çeyrek Sonucu',
        tooltip: 'İlk çeyreğin nasıl biteceğinin tahmin edildiği oyun tipidir. Üç tahmin vardır; Ev sahibi takım (1), Beraberlik (0), Deplasman takımı (2)'
    },
    '71': {
        name: 'Maç Sonucu (Uzatmalar Dahil)',
        tooltip: 'Maçı kimin kazanacağının (Uzatmalar Dahil) tahmin edildiği oyundur. Oyunda handikap seçeneği yoktur. İki tahmin vardır; Ev sahibi takım, Deplasman takımı.'
    },
    '186': {
        name: 'Uzatma Evet / Hayır ',
        tooltip: 'Maçın berabere bitip uzatmaya gidilip gidilmeyeceğinin tahmin edildiği oyun tipidir. İki tahmin vardır; Evet, Hayır'
    },
    '286': {
        name: 'Handikaplı Maç Sonucu (Uzatmalar Dahil)',
        tooltip: 'Handikap seçeneği bulunan takım, belirlenen sayı kadar maça önde başlamış sayılır (sayı avansı) ve bu sayı hesaba katılarak maç sonucunun (uzatmalar dahil) tahmin edildiği oyun tipidir.'
    },
    '607': {
        name: '1. Oyuncu Set Kazanır',
        tooltip: 'İki tahmin vardır; Evet, Hayır'
    },
    '608': {
        name: '2. Oyuncu Set Kazanır',
        tooltip: 'İki tahmin vardır; Evet, Hayır'
    },
    '606': {
        name: 'İlk Yarı Sonucu',
        tooltip: 'İlk yarının nasıl biteceğinin tahmin edildiği oyun tipidir. Üç tahmin vardır; Ev sahibi takım (1), Beraberlik (0), Deplasman takımı (2)'
    },
    '673': {
        name: '1. Çeyrek Sonucu',
        tooltip: 'İlk çeyreğin nasıl biteceğinin tahmin edildiği oyun tipidir. Üç tahmin vardır; Ev sahibi takım (1), Beraberlik (0), Deplasman takımı (2)'
    },
    '231': {
        name: 'Handikaplı Maç Sonucu (Oyun Handikapı)',
        tooltip: 'Handikap seçeneği bulunan takım, belirlenen set sayısı kadar maça önde başlamış sayılır (set avansı) ve bu sayı hesaba katılarak maçı hangi takımın galip bitireceğinin tahmin edildiği oyun tipidir.'
    },
    '239': {
        name: 'Handikaplı Maç Sonucu (Oyun Handikapı)',
        tooltip: 'Handikap seçeneği bulunan takım, belirlenen set sayısı kadar maça önde başlamış sayılır (set avansı) ve bu sayı hesaba katılarak maçı hangi takımın galip bitireceğinin tahmin edildiği oyun tipidir.'
    },
    '18': {
        name: 'Toplam Sayı Alt/Üst',
        tooltip: 'Her iki takımın maç boyunca kazanacakları toplam sayının programda belirtilen sayının altında veya üstünde olduğunun tahmin edilmesidir.'
    },
    '220': {
        name: 'Maç Skoru',
        tooltip: 'Maç skorunun tahmin edildiği oyun tipidir.'
    },
    '277': {
        name: 'Maç Skoru',
        tooltip: 'Maç skorunun tahmin edildiği oyun tipidir.'
    },
    '16': {
        name: 'Maç Sonucu',
        tooltip: 'Maç sonucunun nasıl biteceğinin tahmin edildiği oyun tipidir. Bu oyunda ikili tahmin yapılamaz. Üç tahmin vardır; Ev sahibi takım (1), Beraberlik (0), Deplasman takımı (2)'
    },
    '185': {
        name: 'Çifte Şans',
        tooltip: 'Maç sonucuna ilişkin bu oyunda, bir tahmin iki farklı sonucu kapsar. Üç tahmin vardır; 1-0 (Ev sahibi takım galibiyeti ve Beraberlik), 0-2 (Beraberlik ve Deplasman takım galibiyeti) ve 1-2 (Ev sahibi ve Deplasman takım galibiyeti)'
    },
    '187': {
        name: 'Handikaplı Maç Sonucu',
        tooltip: 'Handikap seçeneği bulunan takım, belirlenen gol kadar maça önde başlamış sayılır (gol avansı).'
    },
    '633': {
        name: 'Çifte Şans',
        tooltip: 'Maç sonucuna ilişkin bu oyunda, bir tahmin iki farklı sonucu kapsar. Üç tahmin vardır; 1-0 (Ev sahibi takım galibiyeti ve Beraberlik), 0-2 (Beraberlik ve Deplasman takım galibiyeti) ve 1-2 (Ev sahibi ve Deplasman takım galibiyeti)'
    },
    '184': {
        name: 'Tek / Çift',
        tooltip: 'Maçta atılacak toplam gol sayısının Tek veya Çift olacağının tahmin edildiği oyun tipidir. Örneğin; maç sonucu 13-21 (34 gol) veya 40-20 (60 gol) ise Çift, 21-12 (33 gol) veya 19-16 (35 gol) ise Tek tercihi kazanan bahistir.'
    },
    '191': {
        name: 'Toplam Oyun Alt/Üst',
        tooltip: 'Her iki oyuncunun maç boyunca kazanacakları toplam oyunun programda belirtilen sayının altında veya üstünde olduğunun tahmin edilmesidir.'
    },
    '20': {
        name: 'Toplam Gol Alt/Üst',
        tooltip: 'Her iki takımın maç boyunca atacakları toplam golün programda belirtilen sayının altında veya üstünde olduğunun tahmin edilmesidir.'
    },
    '133': {
        name: 'Tek / Çift',
        tooltip: 'Maçta atılacak toplam gol sayısının Tek veya Çift olacağının tahmin edildiği oyun tipidir. Örneğin; maç sonucu 13-21 (34 gol) veya 40-20 (60 gol) ise Çift, 21-12 (33 gol) veya 19-16 (35 gol) ise Tek tercihi kazanan bahistir.'
    },
    '9': {
        name: 'Maç Sonucu',
        tooltip: 'Bir maçın sonucunun tahmin edildiği oyun türüdür. İki ihtimali bulunan bu oyunda (01) Ev Sahibi, (02) Deplasman şeklinde kodlanmaktadır.'
    },
    '15': {
        name: 'Maç Sonucu',
        tooltip: 'Maçı kimin kazanacağının tahmin edildiği oyundur. Oyunda handikap seçeneği yoktur. İki tahmin vardır; Ev sahibi 1. Oyuncu, Deplasman 2. Oyuncu'
    },
    '641': {
        name: 'Handikaplı Maç Sonucu',
        tooltip: 'Handikap seçeneği bulunan oyuncu, belirlenen frame sayısı kadar maça önde başlamış sayılır (frame avansı) ve bu sayı hesaba katılarak maçı hangi oyuncunun galip bitireceğinin tahmin edildiği oyun tipidir.'
    },
    '600': {
        name: 'Maç Sonucu',
        tooltip: 'Maçı kimin kazanacağının tahmin edildiği oyundur. Oyunda handikap seçeneği yoktur. İki tahmin vardır; Ev sahibi 1. Oyuncu, Deplasman 2. Oyuncu'
    },
    '602': {
        name: 'Toplam Frame Alt/Üst',
        tooltip: 'Her iki takımın maç boyunca kazanacakları toplam frame\'in programda belirtilen sayının altında veya üstünde olduğunun tahmin edilmesidir.'
    },
    '3-1': {
        name: 'Uzun Vadeli Sonuç',
        tooltip: 'Uzun vadeli etkinliğin nasıl sonuçlanacağının tahmin edilmesidir.'
    },
    '161': {
        name: 'Handikaplı Maç Sonucu',
        tooltip: 'Handikap seçeneği bulunan oyuncu, belirlenen frame sayısı kadar maça önde başlamış sayılır (frame avansı) ve bu sayı hesaba katılarak maçı hangi oyuncunun galip bitireceğinin tahmin edildiği oyun tipidir.'
    },
    '163': {
        name: 'Handikaplı Maç Sonucu',
        tooltip: 'Handikap seçeneği bulunan oyuncu, belirlenen frame sayısı kadar maça önde başlamış sayılır (frame avansı) ve bu sayı hesaba katılarak maçı hangi oyuncunun galip bitireceğinin tahmin edildiği oyun tipidir.'
    },
    '164': {
        name: 'Toplam Gol Alt/Üst',
        tooltip: 'Her iki takımın maç boyunca atacakları toplam golün programda belirtilen sayının altında veya üstünde olduğunun tahmin edilmesidir.'
    },
    '146': {
        name: 'Birinci Set Altı/Üstü',
        tooltip: 'Her iki takımın birinci set boyunca atacakları toplam sayının programda belirtilen sayının altında veya üstünde olduğunun tahmin edilmesidir.'
    },
    '157': {
        name: 'İkinci Set Altı/Üstü',
        tooltip: 'Her iki takımın ikinci set boyunca atacakları toplam sayının programda belirtilen sayının altında veya üstünde olduğunun tahmin edilmesidir.'
    },
    '190': {
        name: 'Beşinci Set Altı/Üstü',
        tooltip: 'Her iki takımın beşinci set boyunca atacakları toplam sayının programda belirtilen sayının altında veya üstünde olduğunun tahmin edilmesidir.'
    },
    '21': {
        name: 'Toplam Gol Altı/Üstü',
        tooltip: 'Her iki takımın maç boyunca atacakları toplam golün programda belirtilen sayının altında veya üstünde olduğunun tahmin edilmesidir.'
    },
    '702': {
        name: 'Set Handikap',
        tooltip: 'Belirtilen oyuncuya verilen set avansıdır. Set avansı verilen oyuncu, maça verilen set sayısı kadar önde başlar. İki tahmin vardır; Ev Sahibi, Deplasman.'
    },
    '712': {
        name: 'Set Handikap',
        tooltip: 'Belirtilen oyuncuya verilen set avansıdır. Set avansı verilen oyuncu, maça verilen set sayısı kadar önde başlar. İki tahmin vardır; Ev Sahibi, Deplasman.'
    },
    '701': {
        name: 'Toplam Oyun Tek/Çift',
        tooltip: 'Bir maçta oynanacak olan toplam oyunun tek ya da çift sayı ile biteceğinin tahmin edildiği oyun türüdür. İki tahmin vardır; Tek, Çift.'
    },
    '711': {
        name: 'Toplam Oyun Tek/Çift',
        tooltip: 'Bir maçta oynanacak olan toplam oyunun tek ya da çift sayı ile biteceğinin tahmin edildiği oyun türüdür. İki tahmin vardır; Tek, Çift.'
    },
    '703': {
        name: 'Maç Sonucu ve Altı/Üstü',
        tooltip: 'Kombine tahminin yapıldığı oyun türüdür. Aynı anda hem maç sonucunun hem de oynanacak toplam oyun sayısının belirlenen sayıdan daha az veya daha fazla olacağının tahmini yapılır.'
    },
    '713': {
        name: 'Maç Sonucu ve Altı/Üstü',
        tooltip: 'Kombine tahminin yapıldığı oyun türüdür. Aynı anda hem maç sonucunun hem de oynanacak toplam oyun sayısının belirlenen sayıdan daha az veya daha fazla olacağının tahmini yapılır.'
    },
    '704': {
        name: 'Oyun Vermeden Set Kazanılır mı',
        tooltip: 'Karşılaşmada taraflardan herhangi birinin oyun vermeden set kazanıp kazanmayacağının tahmini yapılır. İki tahmin vardır; Evet, Hayır'
    },
    '714': {
        name: 'Oyun Vermeden Set Kazanılır mı',
        tooltip: 'Karşılaşmada taraflardan herhangi birinin oyun vermeden set kazanıp kazanmayacağının tahmini yapılır. İki tahmin vardır; Evet, Hayır'
    },
    '705': {
        name: 'İlk Set Sonucu/Maç Sonucu',
        tooltip: 'Maçın ilk setinin sonucu ile maç sonucunun kombine edildiği oyun türüdür.'
    },
    '715': {
        name: 'İlk Set Sonucu/Maç Sonucu',
        tooltip: 'Maçın ilk setinin sonucu ile maç sonucunun kombine edildiği oyun türüdür.'
    },
    '709': {
        name: 'Ev Sahibi Sadece Bir Set Kazanır',
        tooltip: 'Maç sonucunda ev sahibinin sadece bir set kazanıp kazanmayacağının tahmin edildiği oyun türüdür. İki tahmin vardır; Evet, Hayır'
    },
    '719': {
        name: 'Ev Sahibi Sadece Bir Set Kazanır',
        tooltip: 'Maç sonucunda ev sahibinin sadece bir set kazanıp kazanmayacağının tahmin edildiği oyun türüdür. İki tahmin vardır; Evet, Hayır'
    },
    '710': {
        name: 'Deplasman Sadece Bir Set Kazanır',
        tooltip: 'Maç sonucunda deplasman takımının sadece bir set kazanıp kazanmayacağının tahmin edildiği oyun türüdür. İki tahmin vardır; Evet, Hayır'
    },
    '720': {
        name: 'Deplasman Sadece Bir Set Kazanır',
        tooltip: 'Maç sonucunda deplasman takımının sadece bir set kazanıp kazanmayacağının tahmin edildiği oyun türüdür. İki tahmin vardır; Evet, Hayır'
    },
    '718': {
        name: '1. set 1. oyun skoru',
        tooltip: 'Belirtilen setteki belirtilen oyunun hangi skorla sonuçlanacağının tahmin edildiği oyun türüdür.'
    },
    '743': {
        name: '2. set 1. oyun skoru',
        tooltip: 'Belirtilen setteki belirtilen oyunun hangi skorla sonuçlanacağının tahmin edildiği oyun türüdür.'
    },
    '744': {
        name: '3. set 1. oyun skoru',
        tooltip: 'Belirtilen setteki belirtilen oyunun hangi skorla sonuçlanacağının tahmin edildiği oyun türüdür.'
    },
    '745': {
        name: '4. set 1. oyun skoru',
        tooltip: 'Belirtilen setteki belirtilen oyunun hangi skorla sonuçlanacağının tahmin edildiği oyun türüdür.'
    },
    '746': {
        name: '5. set 1. oyun skoru',
        tooltip: 'Belirtilen setteki belirtilen oyunun hangi skorla sonuçlanacağının tahmin edildiği oyun türüdür.'
    },
    '753': {
        name: 'Kim Kazanır'
    },
    '757': {
        name: 'En Hızlı Tur'
    },
    '758': {
        name: 'İlk 3\'e kimler girer'
    },
    '741': {
        name: 'Beraberlikte İade',
        tooltip: 'Maçı hangi tarafın kazanacağının tahmin edildiği ve skorun eşit olması durumunda oranın bir (1.00) sayılacağı oyun türüdür.'
    },
    '747': {
        name: 'Deplasman İlk Yarı Altı/Üstü',
        tooltip: 'Deplasman takımının ilk yarıda atacağı toplam sayıya göre tahmin yapılır.'
    },
    '748': {
        name: 'Hangi Yarıda Daha Fazla Sayı Olur',
        tooltip: 'Hangi yarıda daha fazla sayı atılacağının tahmin edildiği oyun türüdür. 3 tahmin vardır; 1. Yarı, 2. Yarı, Eşit.'
    },
    '749': {
        name: '1. Çeyrek Altı/Üstü',
        tooltip: 'Her iki takımın belirtilen çeyrekte atacakları toplam sayının belirlenen sayının altında veya üstünde olacağının tahmin edildiği oyun türüdür.'
    },
    '750': {
        name: 'Sayı Aralığı (Uzatmalar Hariç)',
        tooltip: ''
    },
    '769': {
        name: 'Sayı Aralığı (Uzatmalar Hariç)',
        tooltip: ''
    },
    '742': {
        name: '1. Çeyrek Altı/Üstü',
        tooltip: 'Her iki takımın belirtilen çeyrekte atacakları toplam sayının belirlenen sayının altında veya üstünde olacağının tahmin edildiği oyun türüdür.'
    },
    '759': {
        name: '3. Çeyrek Altı/Üstü',
        tooltip: 'Her iki takımın belirtilen çeyrekte atacakları toplam sayının belirlenen sayının altında veya üstünde olacağının tahmin edildiği oyun türüdür.'
    },
    '760': {
        name: '4. Çeyrek Altı/Üstü',
        tooltip: 'Her iki takımın belirtilen çeyrekte atacakları toplam sayının belirlenen sayının altında veya üstünde olacağının tahmin edildiği oyun türüdür.'
    },
    '723': {
        name: 'Toplam Set Sayısı',
        tooltip: 'Bir maçta oynanacak olan toplam set sayısının tahmin edildiği oyun türüdür. Üç tahmin vardır; 3, 4, 5.'
    },
    '725': {
        name: 'Ev Sahibi Sadece Bir Set Kazanır',
        tooltip: 'Maç sonucunda ev sahibinin sadece bir set kazanıp kazanmayacağının tahmin edildiği oyun türüdür. İki tahmin vardır; Evet, Hayır'
    },
    '716': {
        name: 'Deplasman Sadece Bir Set Kazanır',
        tooltip: 'Maç sonucunda deplasman takımının sadece bir set kazanıp kazanmayacağının tahmin edildiği oyun türüdür. İki tahmin vardır; Evet, Hayır'
    },
    '726': {
        name: 'Deplasman Sadece Bir Set Kazanır',
        tooltip: 'Maç sonucunda deplasman takımının sadece bir set kazanıp kazanmayacağının tahmin edildiği oyun türüdür. İki tahmin vardır; Evet, Hayır'
    },
    '737': {
        name: 'Korner Tek/Çift',
        tooltip: 'Bir maçta atılacak toplam korner sayısının tek mi çift mi olacağının tahmin edildiği oyun türüdür. İki tahmin vardır; Tek, Çift'
    },
    '727': {
        name: 'Korner Tek/Çift',
        tooltip: 'Bir maçta atılacak toplam korner sayısının tek mi çift mi olacağının tahmin edildiği oyun türüdür. İki tahmin vardır; Tek, Çift'
    },
    '717': {
        name: 'İlk Yarı Skoru',
        tooltip: 'İlk yarı skorunun tahmin edildiği oyun türüdür.'
    },
    '728': {
        name: 'İlk Yarı Skoru',
        tooltip: 'İlk yarı skorunun tahmin edildiği oyun türüdür.'
    },
    '729': {
        name: 'İki Yarı da Alt 1.5',
        tooltip: ''
    },
    '730': {
        name: 'İki Yarı da Üst 1.5',
        tooltip: ''
    },
    '700': {
        name: 'Altı/Üstü ve Karşılıklı Gol',
        tooltip: 'Kombine tahminin yapıldığı oyun türüdür. Aynı anda hem atılacak toplam gol sayısının belirlenen sayıdan daha az veya daha fazla olacağının, hem de karşılıklı gol olup olmayacağının tahmini yapılır. 4 tahmin vardır; Üst ve Var, Alt ve Var, Üst ve Yok, Alt ve Yok'
    },
    '731': {
        name: 'Ev Sahibi Toplam Korner Altı/Üstü',
        tooltip: 'Maçta ev sahibi takımın atacağı toplam korner sayısının belirlenen sayıdan daha az veya daha fazla olacağının tahmin edildiği oyun türüdür.'
    },
    '732': {
        name: 'Deplasman Toplam Korner Altı/Üstü',
        tooltip: 'Maçta deplasman takımının atacağı toplam korner sayısının belirlenen sayıdan daha az veya daha fazla olacağının tahmin edildiği oyun türüdür.'
    },
    '733': {
        name: 'Ev Sahibi Toplam Kart Altı/Üstü',
        tooltip: 'Maçta ev sahibi takıma gösterilecek toplam kart sayısının belirlenen sayıdan daha az veya daha fazla olacağının tahmin edildiği oyun türüdür.  Sarı kart 1 kart olarak ve kırmızı veya çift sarıdan kırmızı kart 2 kart olarak sayılır. Bir oyuncu için kırmızı karta neden olan ikinci sarı kart değerlendirmeye alınmaz.'
    },
    '734': {
        name: 'Deplasman Toplam Kart Altı/Üstü',
        tooltip: 'Maçta deplasman takımına gösterilecek toplam kart sayısının belirlenen sayıdan daha az veya daha fazla olacağının tahmin edildiği oyun türüdür.  Sarı kart 1 kart olarak ve kırmızı veya çift sarıdan kırmızı kart 2 kart olarak sayılır. Bir oyuncu için kırmızı karta neden olan ikinci sarı kart değerlendirmeye alınmaz.'
    },
    '735': {
        name: 'İlk Yarı Karşılıklı Gol',
        tooltip: 'Karşılaşmanın ilk yarısında her iki takımın da gol atıp atamayacağının tahmin edildiği oyun türüdür.'
    },
    '696': {
        name: 'Beraberlikte İade',
        tooltip: '90 dakika sonunda maçın nasıl biteceğinin tahmin edildiği ve skorun eşit olması durumunda oranın bir (1.00) sayılacağı oyun türüdür.'
    },
    '706': {
        name: 'Beraberlikte İade',
        tooltip: '90 dakika sonunda maçın nasıl biteceğinin tahmin edildiği ve skorun eşit olması durumunda oranın bir (1.00) sayılacağı oyun türüdür.'
    },
    // '736': {
    //   name: 'Sıradaki Korneri Hangi Takım Atar',
    //   tooltip: 'Tahminin yapıldığı andan sonra ilk korneri hangi takımın atacağının tahmin edildiği oyun türüdür. Üç tahmin vardır; Ev sahibi takım, Olmaz, Deplasman takımı.'
    // },
    '722': {
        name: 'Ev Sahibi İlk Yarı Altı/Üstü',
        tooltip: 'Ev sahibi takımın maçın ilk yarısında atacağı toplam gol sayısının belirlenen sayıdan az veya daha fazla olacağının tahmin edildiği oyun türüdür.'
    },
    '738': {
        name: 'Deplasman İlk Yarı Altı/Üstü',
        tooltip: 'Deplasman takımının maçın ilk yarısında atacağı toplam gol sayısının belirlenen sayıdan az veya daha fazla olacağının tahmin edildiği oyun türüdür.'
    },
    '724': {
        name: 'İlk Yarı Sonucu ve İlk Yarı Altı/Üstü',
        tooltip: 'Kombine tahminin yapıldığı oyun türüdür. Aynı anda hem ilk yarı sonucunun hem de ilk yarıda atılacak toplam gol sayısının belirlenen sayıdan daha az veya daha fazla olacağının tahmini yapılır.'
    },
    '739': {
        name: 'İlk Yarı Sonucu ve İlk Yarı Altı/Üstü',
        tooltip: 'Kombine tahminin yapıldığı oyun türüdür. Aynı anda hem ilk yarı sonucunun hem de ilk yarıda atılacak toplam gol sayısının belirlenen sayıdan daha az veya daha fazla olacağının tahmini yapılır.'
    },
    '698': {
        name: 'Maç Sonucu ve Karşılıklı Gol',
        tooltip: 'Kombine tahminin yapıldığı oyun türüdür. Aynı anda hem karşılaşmanın nasıl sonuçlanacağının, hem de karşılaşmada her iki takımın da gol atıp atamayacağının tahmini yapılır. 6 tahmin vardır; 1 ve Var, 1 ve Yok, 0 ve Var, 0 ve Yok, 2 ve Var, 2 ve Yok'
    },
    '708': {
        name: 'Maç Sonucu ve Karşılıklı Gol',
        tooltip: 'Kombine tahminin yapıldığı oyun türüdür. Aynı anda hem karşılaşmanın nasıl sonuçlanacağının, hem de karşılaşmada her iki takımın da gol atıp atamayacağının tahmini yapılır. 6 tahmin vardır; 1 ve Var, 1 ve Yok, 0 ve Var, 0 ve Yok, 2 ve Var, 2 ve Yok'
    },
    '699': {
        name: 'İlk Yarı Sonucu ve İlk Yarı Karşılıklı Gol',
        tooltip: 'Kombine tahminin yapıldığı oyun türüdür. Aynı anda hem karşılaşmanın ilk yarısının nasıl sonuçlanacağının, hem de karşılaşmanın ilk yarısında her iki takımın da gol atıp atamayacağının tahmini yapılır. 6 tahmin vardır; 1 ve Var, 1 ve Yok, 0 ve Var, 0 ve Yok, 2 ve Var, 2 ve Yok'
    },
    '736': {
        name: 'Beraberlik veya Üst',
        tooltip: 'Karşılaşmada ev sahibi ve deplasman takımının atacağı gollerin eşit olup olmayacağının veya maç sonucunun belirlenen sayıdan az veya daha fazla olacağının tahmin edildiği oyun türüdür. İki tahmin vardır; Evet, Hayır'
    },
    '740': {
        name: 'Hangi Takım Tur Atlar',
        tooltip: 'Bir eşleşmede hangi tarafın tur atlayacağının tahmin edildiği oyun türüdür. Uzatmalar ve seri penaltı atışları dahildir. İki seçenek vardır; Ev Sahibi Takım, Deplasman Takımı'
    },
    '707': {
        name: 'İlk Yarı Kalanını Kim Kazanır',
        tooltip: 'Tahminin yapılacağı dakikada mevcut skor dikkate alınmadan (yapılan bahis öncesinde atılan goller dikkate alınmaksızın) maçın ilk yarısının geri kalanının sonucu tahmin edilir. Üç tahmin vardır; Ev sahibi takım, Beraberlik, Deplasman takımı'
    },
    '754': {
        name: 'Hangi Takım Kazanır',
        tooltip: ''
    },
    '755': {
        name: 'Kim Daha Üstte Bitirir',
        tooltip: ''
    },
    '756': {
        name: 'Hangi Takım Daha Üstte Bitirir',
        tooltip: ''
    },
    '601': {
        name: 'Maç Sonucu (Uzatmalar Dahil)',
        tooltip: '',
    },
    '135': {
        name: 'Tek/Çift',
        tooltip: '',
    },
    '126': {
        name: 'İlk Periyot Sonucu',
        tooltip: '',
    },
    '137': {
        name: 'İkinci Periyot Sonucu',
        tooltip: '',
    },
    '158': {
        name: 'Tek/Çift',
        tooltip: '',
    },
    '617': {
        name: 'Hangi Takım Kaç Farkla Kazanır',
        tooltip: '',
    },
    '127': {
        name: 'Üçüncü Periyot Sonucu',
        tooltip: '',
    },
    '37': {
        name: 'Üçüncü Periyot Sonucu',
        tooltip: '',
    },
    '639': {
        name: 'Hangi Takım Kaç Farkla Kazanır',
        tooltip: '',
    },
    '120': {
        name: 'Maç Sonucu (Uzatmalar Dahil)',
    },
    '128': {
        name: 'Çifte Şans',
    },
    '767': {
        name: '1. Set 4. Oyun Deuce Olur mu',
    },
    '768': undefined,
};
export var listOfOddsContainingPlayerNames = [
    '3',
    '12',
    '788',
    '789',
    '790',
    '791',
    '792',
    '793',
    '794',
    '795',
    '796',
    '797',
    '798',
    '799',
    '800'
];
export var notInlineMarketList = ["5498", "5499", "5503", "5504", "5506", "5500", "11381", "5501", "5502", "5511"];
